// import { useEffect, useState } from 'react'
// import { FaEdit, FaTrash, FaUserPlus, FaSearch, FaFilter } from 'react-icons/fa'
// import Card from '../admincomponents/Card'
// import Table from '../admincomponents/Table'
// import axios from 'axios'
// import Swal from 'sweetalert2'

// const UserManagement = () => {
//   const [showAddModal, setShowAddModal] = useState(false)
//   const [showEditModal, setShowEditModal] = useState(false)
//   const [showDeleteModal, setShowDeleteModal] = useState(false)
//   const [currentUser, setCurrentUser] = useState(null)
//   const [searchTerm, setSearchTerm] = useState('')
//   const [filterRole, setFilterRole] = useState('')
//   const [filterStatus, setFilterStatus] = useState('')
//   const [users, setUsers] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     first_name: '',
//     last_name: '',
//     mobile_number: '',
//     role_id: '',
//   })

//   const fetchUsers = () => {
//     setLoading(true)
//     axios
//       .get('https://tdtlworld.com/dss-kaas-backend/lms/all-users/', {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => {
//         const mappedUsers = res.data.users.map((user) => ({
//           id: user.user_id,
//           name: `${user.first_name} ${user.last_name}`.trim(),
//           email: user.email,
//           status: 'Active',
//           phone: user.mobile_number || 'N/A',
//           address: user.address || 'N/A',
//           role_id: user.role_id,
//           role:
//             user.role_id === 2
//               ? 'Student'
//               : user.role_id === 3
//               ? 'Instructor'
//               : user.role_id === 4
//               ? 'Trainer'
//               : 'Admin',
//           first_name: user.first_name,
//           last_name: user.last_name,
//         }))
//         setUsers(mappedUsers)
//         setLoading(false)
//       })
//       .catch((err) => {
//         console.error(err)
//         setLoading(false) // ✅ Add it here to handle errors too
//       })
//   }
//   useEffect(() => {
//     fetchUsers()
//   }, [])

//   // Filter users based on search term and filters
//   const filteredUsers = users.filter((user) => {
//     const matchesSearch =
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.email.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesRole = filterRole === '' || user.role === filterRole
//     const matchesStatus = filterStatus === '' || user.status === filterStatus

//     return matchesSearch && matchesRole && matchesStatus
//   })

//   // Table columns configuration
//   const columns = [
//     { key: 'name', label: 'Name', sortable: true },
//     { key: 'email', label: 'Email', sortable: true },
//     { key: 'role', label: 'Role', sortable: true },
//     // {
//     //   key: 'status',
//     //   label: 'Status',
//     //   sortable: true,
//     //   render: (row) => (
//     //     <span
//     //       style={{
//     //         padding: '3px 8px',
//     //         borderRadius: '12px',
//     //         fontSize: '12px',
//     //         backgroundColor:
//     //           row.status === 'Active'
//     //             ? '#e6f7e6'
//     //             : row.status === 'Pending'
//     //             ? '#fff8e6'
//     //             : '#ffe6e6',
//     //         color:
//     //           row.status === 'Active'
//     //             ? '#4caf50'
//     //             : row.status === 'Pending'
//     //             ? '#ff9800'
//     //             : '#f44336',
//     //       }}
//     //     >
//     //       {row.status}
//     //     </span>
//     //   ),
//     // },
//     {
//       key: 'actions',
//       label: 'Actions',
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: 'flex', gap: '10px' }}>
//           <button
//             onClick={() => handleEditClick(row)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#7366ff',
//               cursor: 'pointer',
//               fontSize: '16px',
//             }}
//           >
//             <FaEdit />
//           </button>
//           <button
//             onClick={() => handleDeleteClick(row)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#ff5370',
//               cursor: 'pointer',
//               fontSize: '16px',
//             }}
//           >
//             <FaTrash />
//           </button>
//         </div>
//       ),
//     },
//   ]

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setFormData({
//       ...formData,
//       [name]: value,
//     })
//   }

//   // Handle edit user click
//   const handleEditClick = (user) => {
//     setCurrentUser(user)
//     setFormData({
//       first_name: user.first_name,
//       last_name: user.last_name,
//       email: user.email,
//       role: user.role,
//       status: user.status,
//       phone: user.phone,
//       address: user.address,
//     })
//     setShowEditModal(true)
//   }

//   // Handle delete user click
//   const handleDeleteClick = (user) => {
//     console.log('User:', user)
//     setCurrentUser(user)
//     setShowDeleteModal(true)
//   }
//   const token = localStorage.getItem('jwttoken')

//   const handleAddSubmit = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     try {
//       await axios.post(
//         'https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/',
//         { ...formData, role_id: parseInt(formData.role_id, 10) },
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowAddModal(false)
//       setFormData({
//         email: '',
//         password: '',
//         first_name: '',
//         last_name: '',
//         mobile_number: '',
//         role_id: '',
//       })
//       fetchUsers()
//       Swal.fire('Success', 'User added successfully!', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to add user:', error)
//       Swal.fire('Error', 'Failed to add user', 'error')
//     }
//   }

//   // Handle edit user form submit
//   const handleEditSubmit = async (e) => {
//     e.preventDefault()
//     const roleMap = { Student: 2, Instructor: 3, Trainer: 4, Admin: 1 }
//     const payload = { ...formData, role_id: roleMap[formData.role] }
//     setLoading(true)
//     try {
//       await axios.patch(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-update/${currentUser.id}/`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowEditModal(false)
//       fetchUsers()
//       Swal.fire('Success', 'User updated successfully!', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to update user:', error)
//       Swal.fire('Error', 'Failed to update user', 'error')
//     }
//   }

//   // Handle delete user confirmation
//   const handleDeleteConfirm = async () => {
//     setLoading(true)
//     try {
//       await axios.delete(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-delete/${currentUser.id}/`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowDeleteModal(false)
//       fetchUsers()
//       Swal.fire('Deleted!', 'User has been deleted.', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to delete user:', error)
//       Swal.fire('Error', 'Failed to delete user', 'error')
//     }
//   }

//   // Modal backdrop style
//   const modalBackdropStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 1000,
//   }

//   // Modal content style
//   const modalContentStyle = {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     width: '500px',
//     maxWidth: '90%',
//     maxHeight: '90vh',
//     overflowY: 'auto',
//   }

//   return (
//     <div>
//       <h1 style={{ marginBottom: '20px', color: '#333' }}>User Management</h1>

//       <Card>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '15px',
//             marginBottom: '20px',
//           }}
//         >
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               position: 'relative',
//               width: '300px',
//             }}
//           >
//             <FaSearch
//               style={{
//                 position: 'absolute',
//                 left: '10px',
//                 color: '#888',
//               }}
//             />
//             <input
//               type='text'
//               placeholder='Search users...'
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '8px 10px 8px 35px',
//                 border: '1px solid #ddd',
//                 borderRadius: '5px',
//                 width: '100%',
//               }}
//             />
//           </div>

//           <div
//             style={{
//               display: 'flex',
//               gap: '10px',
//               flexWrap: 'wrap',
//             }}
//           >
//             <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
//               <FaFilter style={{ color: '#888' }} />
//               <select
//                 value={filterRole}
//                 onChange={(e) => setFilterRole(e.target.value)}
//                 style={{
//                   padding: '8px 10px',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                 }}
//               >
//                 <option value=''>All Roles</option>
//                 <option value='Student'>Student</option>
//                 <option value='Instructor'>Instructor</option>
//                 {/* <option value='Admin'>Admin</option> */}
//               </select>
//             </div>

//             {/* <div>
//               <select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 style={{
//                   padding: '8px 10px',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                 }}
//               >
//                 <option value=''>All Status</option>
//                 <option value='Active'>Active</option>
//                 <option value='Inactive'>Inactive</option>
//                 <option value='Pending'>Pending</option>
//               </select>
//             </div> */}

//             <button
//               onClick={() => setShowAddModal(true)}
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '5px',
//                 padding: '8px 15px',
//                 background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '5px',
//                 cursor: 'pointer',
//               }}
//             >
//               <FaUserPlus />
//               Add User
//             </button>
//           </div>
//         </div>

//         {loading ? (
//           <div style={{ textAlign: 'center', padding: '20px' }}>
//             <div className='spinner-border text-primary' role='status'>
//               <span className='visually-hidden'>Loading...</span>
//             </div>
//           </div>
//         ) : (
//           <Table
//             columns={columns}
//             data={filteredUsers}
//             pagination={true}
//             itemsPerPage={5}
//           />
//         )}
//       </Card>

//       {/* Add User Modal */}
//       {showAddModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: '20px' }}>Add New User</h2>
//             <form onSubmit={handleAddSubmit}>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   First Name
//                 </label>
//                 <input
//                   type='text'
//                   name='first_name'
//                   value={formData.first_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Last Name
//                 </label>
//                 <input
//                   type='text'
//                   name='last_name'
//                   value={formData.last_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Email
//                 </label>
//                 <input
//                   type='email'
//                   name='email'
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Role
//                 </label>
//                 <select
//                   name='role_id'
//                   value={formData.role_id}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value=''>Choose Role</option>
//                   <option value='2'>Student</option>
//                   <option value='3'>Instructor</option>
//                   <option value='4'>Trainer</option>
//                 </select>
//               </div>

//               {/* <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Status
//                 </label>
//                 <select
//                   name='status'
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Active'>Active</option>
//                   <option value='Inactive'>Inactive</option>
//                   <option value='Pending'>Pending</option>
//                 </select>
//               </div> */}

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Mobile Number
//                 </label>
//                 <input
//                   type='text'
//                   name='mobile_number'
//                   value={formData.mobile_number}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Password
//                 </label>
//                 <input
//                   type='password'
//                   name='password'
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   gap: '10px',
//                 }}
//               >
//                 <button
//                   type='button'
//                   onClick={() => setShowAddModal(false)}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#f5f5f5',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type='submit'
//                   style={{
//                     padding: '8px 15px',
//                     background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Add User
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Edit User Modal */}
//       {showEditModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: '20px' }}>Edit User</h2>
//             <form onSubmit={handleEditSubmit}>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   First Name
//                 </label>
//                 <input
//                   type='text'
//                   name='first_name'
//                   value={formData.first_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Last Name
//                 </label>
//                 <input
//                   type='text'
//                   name='last_name'
//                   value={formData.last_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Email
//                 </label>
//                 <input
//                   type='email'
//                   name='email'
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Role
//                 </label>
//                 <select
//                   name='role'
//                   value={formData.role}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Student'>Student</option>
//                   <option value='Instructor'>Instructor</option>
//                   <option value='Admin'>Admin</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Status
//                 </label>
//                 <select
//                   name='status'
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Active'>Active</option>
//                   <option value='Inactive'>Inactive</option>
//                   <option value='Pending'>Pending</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Phone
//                 </label>
//                 <input
//                   type='text'
//                   name='phone'
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Password
//                 </label>
//                 <input
//                   type='password'
//                   name='password'
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   gap: '10px',
//                 }}
//               >
//                 <button
//                   type='button'
//                   onClick={() => setShowEditModal(false)}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#f5f5f5',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type='submit'
//                   style={{
//                     padding: '8px 15px',
//                     background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Delete User Modal */}
//       {showDeleteModal && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: '400px' }}>
//             <h2 style={{ marginBottom: '20px' }}>Confirm Delete</h2>
//             <p style={{ marginBottom: '20px' }}>
//               Are you sure you want to delete the user{' '}
//               <strong>{currentUser?.name}</strong>? This action cannot be
//               undone.
//             </p>
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 gap: '10px',
//               }}
//             >
//               <button
//                 onClick={() => setShowDeleteModal(false)}
//                 style={{
//                   padding: '8px 15px',
//                   background: '#f5f5f5',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteConfirm}
//                 style={{
//                   padding: '8px 15px',
//                   background: '#ff5370',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                 }}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default UserManagement

// import { useEffect, useState } from 'react'
// import { FaEdit, FaTrash, FaUserPlus, FaSearch, FaFilter } from 'react-icons/fa'
// import Card from '../admincomponents/Card'
// import Table from '../admincomponents/Table'
// import axios from 'axios'
// import Swal from 'sweetalert2'

// const UserManagement = () => {
//   const [showAddModal, setShowAddModal] = useState(false)
//   const [showEditModal, setShowEditModal] = useState(false)
//   const [showDeleteModal, setShowDeleteModal] = useState(false)
//   const [currentUser, setCurrentUser] = useState(null)
//   const [searchTerm, setSearchTerm] = useState('')
//   const [filterRole, setFilterRole] = useState('')
//   const [filterStatus, setFilterStatus] = useState('')
//   const [users, setUsers] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     first_name: '',
//     last_name: '',
//     mobile_number: '',
//     role_id: '',
//   })

//   const fetchUsers = () => {
//     setLoading(true)
//     axios
//       .get('https://tdtlworld.com/dss-kaas-backend/lms/all-users/', {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => {
//         const mappedUsers = res.data.users.map((user) => ({
//           id: user.user_id,
//           name: `${user.first_name} ${user.last_name}`.trim(),
//           email: user.email,
//           status: 'Active',
//           phone: user.mobile_number || 'N/A',
//           address: user.address || 'N/A',
//           role_id: user.role_id,
//           role:
//             user.role_id === 2
//               ? 'Student'
//               : user.role_id === 3
//               ? 'Instructor'
//               : user.role_id === 4
//               ? 'Trainer'
//               : 'Admin',
//           first_name: user.first_name,
//           last_name: user.last_name,
//         }))
//         setUsers(mappedUsers)
//         setLoading(false)
//       })
//       .catch((err) => {
//         console.error(err)
//         setLoading(false) // ✅ Add it here to handle errors too
//       })
//   }
//   useEffect(() => {
//     fetchUsers()
//   }, [])

//   // Filter users based on search term and filters
//   const filteredUsers = users.filter((user) => {
//     const matchesSearch =
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.email.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesRole = filterRole === '' || user.role === filterRole
//     const matchesStatus = filterStatus === '' || user.status === filterStatus

//     return matchesSearch && matchesRole && matchesStatus
//   })

//   // Table columns configuration
//   const columns = [
//     { key: 'name', label: 'Name', sortable: true },
//     { key: 'email', label: 'Email', sortable: true },
//     { key: 'role', label: 'Role', sortable: true },
//     // {
//     //   key: 'status',
//     //   label: 'Status',
//     //   sortable: true,
//     //   render: (row) => (
//     //     <span
//     //       style={{
//     //         padding: '3px 8px',
//     //         borderRadius: '12px',
//     //         fontSize: '12px',
//     //         backgroundColor:
//     //           row.status === 'Active'
//     //             ? '#e6f7e6'
//     //             : row.status === 'Pending'
//     //             ? '#fff8e6'
//     //             : '#ffe6e6',
//     //         color:
//     //           row.status === 'Active'
//     //             ? '#4caf50'
//     //             : row.status === 'Pending'
//     //             ? '#ff9800'
//     //             : '#f44336',
//     //       }}
//     //     >
//     //       {row.status}
//     //     </span>
//     //   ),
//     // },
//     {
//       key: 'actions',
//       label: 'Actions',
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: 'flex', gap: '10px' }}>
//           <button
//             onClick={() => handleEditClick(row)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#7366ff',
//               cursor: 'pointer',
//               fontSize: '16px',
//             }}
//           >
//             <FaEdit />
//           </button>
//           <button
//             onClick={() => handleDeleteClick(row)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#ff5370',
//               cursor: 'pointer',
//               fontSize: '16px',
//             }}
//           >
//             <FaTrash />
//           </button>
//         </div>
//       ),
//     },
//   ]

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setFormData({
//       ...formData,
//       [name]: value,
//     })
//   }

//   // Handle edit user click
//   const handleEditClick = (user) => {
//     setCurrentUser(user)
//     setFormData({
//       first_name: user.first_name,
//       last_name: user.last_name,
//       email: user.email,
//       role: user.role,
//       status: user.status,
//       phone: user.phone,
//       address: user.address,
//     })
//     setShowEditModal(true)
//   }

//   // Handle delete user click
//   const handleDeleteClick = (user) => {
//     console.log('User:', user)
//     setCurrentUser(user)
//     setShowDeleteModal(true)
//   }
//   const token = localStorage.getItem('jwttoken')

//   const handleAddSubmit = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     try {
//       await axios.post(
//         'https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/',
//         { ...formData, role_id: parseInt(formData.role_id, 10) },
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowAddModal(false)
//       setFormData({
//         email: '',
//         password: '',
//         first_name: '',
//         last_name: '',
//         mobile_number: '',
//         role_id: '',
//       })
//       fetchUsers()
//       Swal.fire('Success', 'User added successfully!', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to add user:', error)
//       Swal.fire('Error', 'Failed to add user', 'error')
//     }
//   }

//   // Handle edit user form submit
//   const handleEditSubmit = async (e) => {
//     e.preventDefault()
//     const roleMap = { Student: 2, Instructor: 3, Trainer: 4, Admin: 1 }
//     const payload = { ...formData, role_id: roleMap[formData.role] }
//     setLoading(true)
//     try {
//       await axios.patch(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-update/${currentUser.id}/`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowEditModal(false)
//       fetchUsers()
//       Swal.fire('Success', 'User updated successfully!', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to update user:', error)
//       Swal.fire('Error', 'Failed to update user', 'error')
//     }
//   }

//   // Handle delete user confirmation
//   const handleDeleteConfirm = async () => {
//     setLoading(true)
//     try {
//       await axios.delete(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-delete/${currentUser.id}/`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       setLoading(false)
//       setShowDeleteModal(false)
//       fetchUsers()
//       Swal.fire('Deleted!', 'User has been deleted.', 'success')
//     } catch (error) {
//       setLoading(false)
//       console.error('Failed to delete user:', error)
//       Swal.fire('Error', 'Failed to delete user', 'error')
//     }
//   }

//   // Modal backdrop style
//   const modalBackdropStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 1000,
//   }

//   // Modal content style
//   const modalContentStyle = {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     width: '500px',
//     maxWidth: '90%',
//     maxHeight: '90vh',
//     overflowY: 'auto',
//   }

//   return (
//     <div>
//       <h1 style={{ marginBottom: '20px', color: '#333' }}>User Management</h1>

//       <Card>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '15px',
//             marginBottom: '20px',
//           }}
//         >
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               position: 'relative',
//               width: '300px',
//             }}
//           >
//             <FaSearch
//               style={{
//                 position: 'absolute',
//                 left: '10px',
//                 color: '#888',
//               }}
//             />
//             <input
//               type='text'
//               placeholder='Search users...'
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '8px 10px 8px 35px',
//                 border: '1px solid #ddd',
//                 borderRadius: '5px',
//                 width: '100%',
//               }}
//             />
//           </div>

//           <div
//             style={{
//               display: 'flex',
//               gap: '10px',
//               flexWrap: 'wrap',
//             }}
//           >
//             <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
//               <FaFilter style={{ color: '#888' }} />
//               <select
//                 value={filterRole}
//                 onChange={(e) => setFilterRole(e.target.value)}
//                 style={{
//                   padding: '8px 10px',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                 }}
//               >
//                 <option value=''>All Roles</option>
//                 <option value='Student'>Student</option>
//                 <option value='Instructor'>Instructor</option>
//                 {/* <option value='Admin'>Admin</option> */}
//               </select>
//             </div>

//             {/* <div>
//               <select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 style={{
//                   padding: '8px 10px',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                 }}
//               >
//                 <option value=''>All Status</option>
//                 <option value='Active'>Active</option>
//                 <option value='Inactive'>Inactive</option>
//                 <option value='Pending'>Pending</option>
//               </select>
//             </div> */}

//             <button
//               onClick={() => setShowAddModal(true)}
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '5px',
//                 padding: '8px 15px',
//                 background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '5px',
//                 cursor: 'pointer',
//               }}
//             >
//               <FaUserPlus />
//               Add User
//             </button>
//           </div>
//         </div>

//         {loading ? (
//           <div style={{ textAlign: 'center', padding: '20px' }}>
//             <div className='spinner-border text-primary' role='status'>
//               <span className='visually-hidden'>Loading...</span>
//             </div>
//           </div>
//         ) : (
//           <Table
//             columns={columns}
//             data={filteredUsers}
//             pagination={true}
//             itemsPerPage={5}
//           />
//         )}
//       </Card>

//       {/* Add User Modal */}
//       {showAddModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: '20px' }}>Add New User</h2>
//             <form onSubmit={handleAddSubmit}>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   First Name
//                 </label>
//                 <input
//                   type='text'
//                   name='first_name'
//                   value={formData.first_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Last Name
//                 </label>
//                 <input
//                   type='text'
//                   name='last_name'
//                   value={formData.last_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Email
//                 </label>
//                 <input
//                   type='email'
//                   name='email'
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Role
//                 </label>
//                 <select
//                   name='role_id'
//                   value={formData.role_id}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value=''>Choose Role</option>
//                   <option value='2'>Student</option>
//                   <option value='3'>Instructor</option>
//                   <option value='4'>Trainer</option>
//                 </select>
//               </div>

//               {/* <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Status
//                 </label>
//                 <select
//                   name='status'
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Active'>Active</option>
//                   <option value='Inactive'>Inactive</option>
//                   <option value='Pending'>Pending</option>
//                 </select>
//               </div> */}

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Mobile Number
//                 </label>
//                 <input
//                   type='text'
//                   name='mobile_number'
//                   value={formData.mobile_number}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Password
//                 </label>
//                 <input
//                   type='password'
//                   name='password'
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   gap: '10px',
//                 }}
//               >
//                 <button
//                   type='button'
//                   onClick={() => setShowAddModal(false)}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#f5f5f5',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type='submit'
//                   style={{
//                     padding: '8px 15px',
//                     background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Add User
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Edit User Modal */}
//       {showEditModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: '20px' }}>Edit User</h2>
//             <form onSubmit={handleEditSubmit}>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   First Name
//                 </label>
//                 <input
//                   type='text'
//                   name='first_name'
//                   value={formData.first_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>
//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Last Name
//                 </label>
//                 <input
//                   type='text'
//                   name='last_name'
//                   value={formData.last_name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Email
//                 </label>
//                 <input
//                   type='email'
//                   name='email'
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Role
//                 </label>
//                 <select
//                   name='role'
//                   value={formData.role}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Student'>Student</option>
//                   <option value='Instructor'>Instructor</option>
//                   <option value='Admin'>Admin</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Status
//                 </label>
//                 <select
//                   name='status'
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <option value='Active'>Active</option>
//                   <option value='Inactive'>Inactive</option>
//                   <option value='Pending'>Pending</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Phone
//                 </label>
//                 <input
//                   type='text'
//                   name='phone'
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px' }}>
//                   Password
//                 </label>
//                 <input
//                   type='password'
//                   name='password'
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '8px 10px',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                   }}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   gap: '10px',
//                 }}
//               >
//                 <button
//                   type='button'
//                   onClick={() => setShowEditModal(false)}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#f5f5f5',
//                     border: '1px solid #ddd',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type='submit'
//                   style={{
//                     padding: '8px 15px',
//                     background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Delete User Modal */}
//       {showDeleteModal && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: '400px' }}>
//             <h2 style={{ marginBottom: '20px' }}>Confirm Delete</h2>
//             <p style={{ marginBottom: '20px' }}>
//               Are you sure you want to delete the user{' '}
//               <strong>{currentUser?.name}</strong>? This action cannot be
//               undone.
//             </p>
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 gap: '10px',
//               }}
//             >
//               <button
//                 onClick={() => setShowDeleteModal(false)}
//                 style={{
//                   padding: '8px 15px',
//                   background: '#f5f5f5',
//                   border: '1px solid #ddd',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteConfirm}
//                 style={{
//                   padding: '8px 15px',
//                   background: '#ff5370',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                 }}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }   const token = localStorage.getItem("jwttoken")

// export default UserManagement

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import * as XLSX from "xlsx"; // Add this import
// import {
//   FaEdit,
//   FaTrash,
//   FaUserPlus,
//   FaSearch,
//   FaFilter,
//   FaFileExcel,
//   FaEye,
// } from "react-icons/fa";
// // CSC-LIB: Import the library functions
// import { Country, State, City } from "country-state-city";
// import Card from "../admincomponents/Card"; // Assuming Card component path
// import Table from "../admincomponents/Table"; // Assuming Table component path

// // Replace with your actual token or token retrieval logic
// const token =
//   typeof localStorage !== "undefined" ? localStorage.getItem("jwttoken") : null;


// const farmTypeOptions = ["Agriculture", "Livestock", "Poultry", "Aquaculture"];
// const agricultureTypeOptions = ["Crop farming", "Horticulture", "Floriculture"];
// const livestockTypeOptions = ["Dairy", "Sheep & Goat", "Swine"];
// const poultryTypeOptions = ["Layer", "Broiler"];
// const aquacultureTypeOptions = ["Shrimp", "Fish"];
// const doctorSpecializationOptions = ["Small Animal", "Ruminants"];
// const businessNatureOptions = ["Manufacturing", "Treading"];
// const consultantAreaOptions = ["Agriculture", "Dairy", "Swine", "Poultry"];


// // const divisionOptions = [
// //   "Livestock",
// //   "Small Ruminant",
// //   "Companion",
// //   "Poultry",
// //   "Aqua",
// //   "Other",
// // ];

// const initialFormData = {
//   first_name: "",
//   middle_name: "",
//   last_name: "",
//   email: "",
//   confirm_email: "",
//   password: "",
//   confirm_password: "",
//   mobile_number: "",
//   role: "Student",
//   role_id: 2,
//   address_line1: "",
//   village: "",
//   tehsil: "",
//   district: "",
//   state_address: "",
//   country: "",
//   pin_code: "",
//   // CSC-LIB: Add codes for the library to use
//   countryCode: "",
//   stateCode: "",
//   occupation: "Farmer",
//   education: "Secondary",
//   degree: "",
//   farm_type: "",
//   farmer_agriculture_type: "",
//   farmer_livestock_type: "",
//   farmer_poultry_type: "",
//   farmer_aquaculture_type: "",
//   doctor_specialization: "",
//   business_nature: "",
//   business_company_name: "",
//   business_company_address: "",
//   service_company_name: "",
//   service_designation: "",
//   consultant_area: "",
//   employee_id: "",
//   employee_department: "",
//   employee_designation: "",
//   employee_division: "",
//   employee_subdivision:"",
//   employee_headquarter: "",
//   employee_other_department: "",
//   employee_other_designation: "",
//   employee_other_division: "",
//   employee_other_subdivision:"",
// };

// const roleToIdMap = {
//   Student: 2,
//   Instructor: 3,
//   Trainer: 4,
//   Admin: 1,
// };
// const idToRoleMap = {
//   2: "Student",
//   3: "Instructor",
//   4: "Trainer",
//   1: "Admin",
// };

// const UserManagement = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [formLoading, setFormLoading] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterRole, setFilterRole] = useState("");
//   const [formData, setFormData] = useState(initialFormData);
//   const [showUploadModal, setShowUploadModal] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showPreview, setShowPreview] = useState(false);
//   const [importResults, setImportResults] = useState(null);
//   const [showExcelData, setShowExcelData] = useState(false);
//   const [countries, setCountries] = useState([]);
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDistricts, setAvailableDistricts] = useState([]); // Will hold cities
//   const [filteredSubdivisions, setFilteredSubdivisions] = useState([]);

//   const [dropdownOptions, setDropdownOptions] = useState({
//     education: [],
//     occupation: [],
//     designations: [],
//     divisions: [],
//     departments: [],
//     subdivisions:[],
//   });

  
//   // CSC-LIB: Load all countries on component mount
//   useEffect(() => {
//     setCountries(Country.getAllCountries());
//   }, []);

//   // CSC-LIB: Update available states when country changes
//   useEffect(() => {
//     const states = formData.countryCode
//       ? State.getStatesOfCountry(formData.countryCode)
//       : [];
//     setAvailableStates(states);
//     // When country changes, reset state and district
//     if (!states.find((s) => s.isoCode === formData.stateCode)) {
//       setFormData((prev) => ({
//         ...prev,
//         state_address: "",
//         stateCode: "",
//         district: "",
//       }));
//     }
//   }, [formData.countryCode]);

//   // CSC-LIB: Update available districts (cities) when state changes
//   useEffect(() => {
//     const districts =
//       formData.countryCode && formData.stateCode
//         ? City.getCitiesOfState(formData.countryCode, formData.stateCode)
//         : [];
//     setAvailableDistricts(districts);
//     // When state changes, reset district
//     if (!districts.find((d) => d.name === formData.district)) {
//       setFormData((prev) => ({ ...prev, district: "" }));
//     }
//   }, [formData.countryCode, formData.stateCode]);

//  useEffect(() => {
//   if (formData.employee_division && formData.employee_division !== 'Other') {
//     // Filter subdivisions that belong to the selected division
//     const filtered = dropdownOptions.subdivisions.filter(
//       subdiv => subdiv.division.toString() === formData.employee_division
//     );
//     setFilteredSubdivisions(filtered);
//   } else {
//     setFilteredSubdivisions([]);
//   }
// }, [formData.employee_division, dropdownOptions.subdivisions]);

//    const fetchDropdownData = useCallback(async () => {
//   try {
//     const endpoints = [
//       { name: 'education', url: 'https://tdtlworld.com/dss-kaas-backend/master/educations/' },
//       { name: 'occupation', url: 'https://tdtlworld.com/dss-kaas-backend/master/occupations/' },
//       { name: 'designations', url: 'https://tdtlworld.com/dss-kaas-backend/master/designations/' },
//       { name: 'divisions', url: 'https://tdtlworld.com/dss-kaas-backend/master/divisions/' },
//       { name: 'departments', url: 'https://tdtlworld.com/dss-kaas-backend/master/departments/' },
//       { name: 'subdivisions', url: 'https://tdtlworld.com/dss-kaas-backend/master/subdivisions/' },
//     ];

//     const responses = await Promise.all(
//       endpoints.map(async endpoint => {
//         try {
//           const res = await axios.get(endpoint.url, { 
//             headers: { Authorization: `Bearer ${token}` } 
//           });
          
//           // Transform data for divisions and subdivisions
//           if (endpoint.name === 'divisions') {
//             return {
//               name: endpoint.name,
//               data: res.data.map(item => ({
//                 id: item.id.toString(),
//                 name: item.name
//               }))
//             };
//           } else if (endpoint.name === 'subdivisions') {
//             return {
//               name: endpoint.name,
//               data: res.data.map(item => ({
//                 id: item.id.toString(),
//                 name: item.name,
//                 division: item.division.toString() // Make sure this matches your API response
//               }))
//             };
//           }
          
//           return {
//             name: endpoint.name,
//             data: Array.isArray(res.data) ? res.data.map(item => item.name || item) : []
//           };
//         } catch (err) {
//           console.error(`Error fetching ${endpoint.name}:`, err);
//           return { name: endpoint.name, data: [] };
//         }
//       })
//     );

//     const dropdownData = {};
//     responses.forEach(response => {
//       dropdownData[response.name] = response.data;
//     });

//     setDropdownOptions(dropdownData);
//   } catch (error) {
//     console.error('Error fetching dropdown data:', error);
//     Swal.fire("Error", "Could not load dropdown options", "error");
//   }
// }, [token]);

//    const fetchUsers = useCallback(() => {
//     setLoading(true);
//     axios
//       .get("https://tdtlworld.com/dss-kaas-backend/lms/all-users/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => {
//         const mappedUsers = res.data.users.map((user) => ({
//           id: user.user_id,
//           first_name: user.first_name || "",
//           middle_name: user.middle_name || "",
//           last_name: user.last_name || "",
//           name: `${user.first_name || ""} ${user.middle_name || ""} ${
//             user.last_name || ""
//           }`.replace(/\s+/g, " ").trim(),
//           email: user.email || "",
//           mobile_number: user.mobile_number || "N/A",
//           role_id: user.role_id,
//           role: idToRoleMap[user.role_id] || "Unknown Role",
//           address_line1: user.address_line1 || "",
//           village: user.village || "",
//           tehsil: user.tehsil || "",
//           district: user.district || "",
//           state_address: user.state_address || "",
//           country: user.country || "",
//           pin_code: user.pin_code || "",
//           occupation: user.occupation || "",
//           education: user.education || "",
//           degree: user.degree || "",
//           farm_type: user.farm_type || "",
//           farmer_agriculture_type: user.farmer_agriculture_type || "",
//           farmer_livestock_type: user.farmer_livestock_type || "",
//           farmer_poultry_type: user.farmer_poultry_type || "",
//           farmer_aquaculture_type: user.farmer_aquaculture_type || "",
//           doctor_specialization: user.doctor_specialization || "",
//           business_nature: user.business_nature || "",
//           business_company_name: user.business_company_name || "",
//           business_company_address: user.business_company_address || "",
//           service_company_name: user.service_company_name || "",
//           service_designation: user.service_designation || "",
//           consultant_area: user.consultant_area || "",
//           employee_id: user.employee_id || "",
//           employee_department: user.employee_department || "",
//           employee_designation: user.employee_designation || "",
//           employee_division: user.employee_division || "",
//           employee_subdivision: user.employee_subdivision || "",
//           employee_headquarter: user.employee_headquarter || "",
//         }));
//         setUsers(mappedUsers);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching users:", err);
//         Swal.fire("Error", "Could not fetch users. Check API or network.", "error");
//         setLoading(false);
//       });
//   }, [token]);

//   useEffect(() => {
//     fetchDropdownData();
//     fetchUsers();
//   }, [fetchDropdownData, fetchUsers]);

//   useEffect(() => {
//     fetchDropdownData();
//     fetchUsers();
//     setCountries(Country.getAllCountries());
//   }, [fetchDropdownData, fetchUsers]);
  

//    const renderEducationDropdown = () => (
//     <select
//       name="education"
//       value={formData.education}
//       onChange={handleInputChange}
//       required
//       style={inputStyle}
//     >
//       <option value="">Select Education</option>
//       {dropdownOptions.education.map((education, index) => (
//         <option key={index} value={education}>
//           {education}
//         </option>
//       ))}
//     </select>
//   );

//   const renderOccupationDropdown = () => (
//     <select
//       name="occupation"
//       value={formData.occupation}
//       onChange={handleInputChange}
//       required
//       style={inputStyle}
//     >
//       <option value="">Select Occupation</option>
//       {dropdownOptions.occupation.map((occupation, index) => (
//         <option key={index} value={occupation}>
//           {occupation}
//         </option>
//       ))}
//     </select>
//   );

//   const renderDesignationDropdown = () => (
//     <select
//       name="employee_designation"
//       value={formData.employee_designation}
//       onChange={handleInputChange}
//       required
//       style={inputStyle}
//     >
//       <option value="">Select Designation</option>
//       {dropdownOptions.designations.map((designation, index) => (
//         <option key={index} value={designation}>
//           {designation}
//         </option>
//       ))}
//       <option value="Other">Other</option>
//     </select>
//   );

// const renderDivisionDropdown = () => (
//     <select
//       name="employee_division"
//       value={formData.employee_division}
//       onChange={handleInputChange}
//       style={inputStyle}
//       required
//     >
//       <option value="">Select Division</option>
//       {dropdownOptions.divisions.map((division) => (
//         <option key={division.id} value={division.id}>
//           {division.name}
//         </option>
//       ))}
//       <option value="Other">Other</option>
//     </select>
//   );
//  const renderSubDivisionDropdown = () => (
//   <select
//     name="employee_subdivision"
//     value={formData.employee_subdivision}
//     onChange={handleInputChange}
//     style={inputStyle}
//     disabled={!formData.employee_division}
//     required
//   >
//     <option value="">Select SubDivision</option>
//     {filteredSubdivisions.map((subdivision) => (
//       <option key={subdivision.id} value={subdivision.id}>
//         {subdivision.name}
//       </option>
//     ))}
//     <option value="Other">Other</option>
//   </select>
// );
//   const renderDepartmentDropdown = () => (
//     <select
//       name="employee_department"
//       value={formData.employee_department}
//       onChange={handleInputChange}
//       required
//       style={inputStyle}
//     >
//       <option value="">Select Department</option>
//       {dropdownOptions.departments.map((department, index) => (
//         <option key={index} value={department}>
//           {department}
//         </option>
//       ))}
//       <option value="Other">Other</option>
//     </select>
//   );

//   const filteredUsers = users.filter((user) => {
//     const searchTermLower = searchTerm.toLowerCase();
//     const matchesSearch =
//       (user.name && user.name.toLowerCase().includes(searchTermLower)) ||
//       (user.email && user.email.toLowerCase().includes(searchTermLower)) ||
//       (user.mobile_number && user.mobile_number.includes(searchTermLower)) ||
//       (user.occupation &&
//         user.occupation.toLowerCase().includes(searchTermLower));
//     const matchesRole = filterRole === "" || user.role === filterRole;
//     return matchesSearch && matchesRole;
//   });


//   const columns = [
//     { key: "name", label: "Name", sortable: true },
//     { key: "email", label: "Email", sortable: true },
//     { key: "mobile_number", label: "Mobile", sortable: true },
//     { key: "role", label: "Role", sortable: true },
//     { key: "occupation", label: "Occupation", sortable: true },
//     { key: "education", label: "Education", sortable: true },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: "flex", gap: "10px" }}>
//           <button
//             onClick={() => handleEditClick(row)}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#7366ff",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//             aria-label="Edit user"
//           >
//             <FaEdit />
//           </button>
//           <button
//             onClick={() => handleDeleteClick(row)}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#ff5370",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//             aria-label="Delete user"
//           >
//             <FaTrash />
//           </button>
//         </div>
//       ),
//     },
//   ];

//   // CSC-LIB: Updated input handler for location data
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     let newFormData = { ...formData, [name]: value };

//     if (name === "country") {
//       const selectedCountry = Country.getCountryByCode(value);
//       newFormData = {
//         ...newFormData,
//         country: selectedCountry?.name || "",
//         countryCode: selectedCountry?.isoCode || "",
//         // Reset dependent fields
//         state_address: "",
//         stateCode: "",
//         district: "",
//       };
//     } else if (name === "state_address") {
//       const selectedState = State.getStateByCodeAndCountry(
//         value,
//         formData.countryCode
//       );
//       newFormData = {
//         ...newFormData,
//         state_address: selectedState?.name || "",
//         stateCode: selectedState?.isoCode || "",
//         // Reset dependent field
//         district: "",
//       };
//     } else if (name === "role") {
//       newFormData = { ...newFormData, role_id: roleToIdMap[value] || null };
//     } else if (name === "occupation") {
//       const resetFields = {
//         farm_type: "",
//         farmer_agriculture_type: "",
//         farmer_livestock_type: "",
//         farmer_poultry_type: "",
//         farmer_aquaculture_type: "",
//         doctor_specialization: "",
//         business_nature: "",
//         business_company_name: "",
//         business_company_address: "",
//         service_company_name: "",
//         service_designation: "",
//         consultant_area: "",
//         employee_id: "",
//         employee_department: "",
//         employee_designation: "",
//         employee_division: "",
//         employee_headquarter: "",
//         employee_other_department: "",
//         employee_other_designation: "",
//         employee_other_division: "",
//       };
//       newFormData = { ...newFormData, ...resetFields };
//     } else if (name === "farm_type") {
//       newFormData = {
//         ...newFormData,
//         farmer_agriculture_type: "",
//         farmer_livestock_type: "",
//         farmer_poultry_type: "",
//         farmer_aquaculture_type: "",
//       };
//     }else if (name === "employee_division") {
//       // When division changes, reset subdivision
//       newFormData = {
//         ...newFormData,
//         employee_subdivision: "",
//         employee_other_subdivision: ""
//       };
//     }

//     setFormData(newFormData);
//   };

//   const preparePayload = (data) => {
//     const payload = { ...data };
//     payload.role_id = roleToIdMap[data.role] || null;
//     delete payload.confirm_email;
//     delete payload.confirm_password;
//     // CSC-LIB: Remove helper codes not needed by backend
//     delete payload.countryCode;
//     delete payload.stateCode;

//     if (payload.password === "") delete payload.password;
//     if (
//       payload.employee_department === "Other" &&
//       payload.employee_other_department
//     )
//       payload.employee_department = payload.employee_other_department;
//     if (
//       payload.employee_designation === "Other" &&
//       payload.employee_other_designation
//     )
//       payload.employee_designation = payload.employee_other_designation;
//    if (payload.employee_division && payload.employee_division !== 'Other') {
//       const divisionObj = dropdownOptions.divisions.find(d => d.id === payload.employee_division);
//       payload.employee_division = divisionObj ? divisionObj.name : '';
//     } else if (payload.employee_division === 'Other' && payload.employee_other_division) {
//       payload.employee_division = payload.employee_other_division;
//     }

//     // Handle subdivision
//     if (payload.employee_subdivision && payload.employee_subdivision !== 'Other') {
//     const subdivisionObj = dropdownOptions.subdivisions.find(
//       s => s.id.toString() === payload.employee_subdivision
//     );
//     payload.employee_subdivision = subdivisionObj ? subdivisionObj.name : '';
//   } else if (payload.employee_subdivision === 'Other' && payload.employee_other_subdivision) {
//     payload.employee_subdivision = payload.employee_other_subdivision;
//   }
//     delete payload.employee_other_department;
//     delete payload.employee_other_designation;
//     delete payload.employee_other_division;
//     return payload;
//   };

//   const handleAddSubmit = async (e) => {
//     e.preventDefault();
//     if (formData.password !== formData.confirm_password) {
//       Swal.fire("Error", "Passwords do not match!", "error");
//       return;
//     }
//     if (formData.email !== formData.confirm_email) {
//       Swal.fire("Error", "Emails do not match!", "error");
//       return;
//     }
//     setFormLoading(true);
//     const payload = preparePayload(formData);

//     try {
//       await axios.post(
//         "https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/",
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setFormLoading(false);
//       setShowAddModal(false);
//       setFormData(initialFormData);
//       fetchUsers();

//       Swal.fire("Success", "User added successfully!", "success");
//     } catch (error) {
//       setFormLoading(false);

//       console.error(
//         "Failed to add user:",
//         error.response ? error.response : error
//       );

//       let errorMessage = "Server error";

//      if (error.response) {
//   const contentType = error.response.headers["content-type"] || "";

//   if (contentType.includes("application/json")) {
//     const data = error.response.data;
    
//     // Handle string errors
//     if (typeof data === "string") {
//       errorMessage = data;
//     } 
//     // Handle detail/message errors
//     else if (data.detail) {
//       errorMessage = data.detail;
//     } 
//     else if (data.message) {
//       errorMessage = data.message;
//     } 
//     // Handle validation errors
//     else if (typeof data === "object") {
//       const messages = [];
//       for (const key in data) {
//         // Format field name (convert snake_case to Title Case)
//         const fieldName = key.replace(/_/g, ' ')
//                            .replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        
//         // Get the error message(s)
//         const errorText = Array.isArray(data[key]) 
//           ? data[key].join(", ")
//           : data[key];
        
//         // Standardize error messages
//         const displayText = errorText
//           .replace("This field may not be blank.", `${fieldName} is required.`)
//           .replace("This field is required.", `${fieldName} is required.`);
        
//         messages.push(displayText);
//       }
//       errorMessage = messages.join("<br>");
//     }
//   } else {
//     errorMessage = "Unexpected server response. Please try again.";
//   }
// }

// Swal.fire({
//   title: "Error",
//   html: `Failed to add user:<br>${errorMessage}`,
//   icon: "error"
// });
//     }
//   };

//   // CSC-LIB: handleEditClick is now async to handle data lookups
//   const handleEditClick = async (user) => {
//     setCurrentUser(user);

//     // CSC-LIB: Find country and state codes from names saved in the DB
//     const countryData = Country.getAllCountries().find(
//       (c) => c.name === user.country
//     );
//     const stateData = countryData
//       ? State.getStatesOfCountry(countryData.isoCode).find(
//           (s) => s.name === user.state_address
//         )
//       : null;

//       let subdivisionId = '';
//   if (user.employee_subdivision) {
//     const subdivision = dropdownOptions.subdivisions.find(
//       s => s.name === user.employee_subdivision
//     );
//     subdivisionId = subdivision ? subdivision.id.toString() : 'Other';
//   }

//     const userFormData = {
//       ...initialFormData,
//       id: user.id,
//       first_name: user.first_name || "",
//       middle_name: user.middle_name || "",
//       last_name: user.last_name || "",
//       email: user.email || "",
//       confirm_email: user.email || "",
//       mobile_number: user.mobile_number || "",
//       role: user.role || "Student",
//       role_id: user.role_id || 2,
//       address_line1: user.address_line1 || "",
//       village: user.village || "",
//       tehsil: user.tehsil || "",
//       district: user.district || "",
//       state_address: user.state_address || "",
//       country: user.country || "",
//       pin_code: user.pin_code || "",
//       // CSC-LIB: Set the codes for the dropdowns to work
//       countryCode: countryData?.isoCode || "",
//       stateCode: stateData?.isoCode || "",
//       occupation: user.occupation || "",
//       education: user.education || "",
//       degree: user.degree || "",
//       farm_type: user.farm_type || "",
//       farmer_agriculture_type: user.farmer_agriculture_type || "",
//       farmer_livestock_type: user.farmer_livestock_type || "",
//       farmer_poultry_type: user.farmer_poultry_type || "",
//       farmer_aquaculture_type: user.farmer_aquaculture_type || "",
//       doctor_specialization: user.doctor_specialization || "",
//       business_nature: user.business_nature || "",
//       business_company_name: user.business_company_name || "",
//       business_company_address: user.business_company_address || "",
//       service_company_name: user.service_company_name || "",
//       service_designation: user.service_designation || "",
//       consultant_area: user.consultant_area || "",
//       employee_id: user.employee_id || "",
//       employee_department: user.employee_department || "",
//       employee_designation: user.employee_designation || "",
//       employee_division: user.employee_division || "",
//  employee_subdivision: subdivisionId,
//     employee_other_subdivision: subdivisionId === 'Other' ? user.employee_subdivision : '',
//           employee_headquarter: user.employee_headquarter || "",
//       password: "",
//       confirm_password: "",
//     };

//    if (
//   userFormData.employee_department &&
//   !dropdownOptions.departments.includes(userFormData.employee_department)
// ) {
//   userFormData.employee_other_department = userFormData.employee_department;
//   userFormData.employee_department = "Other";
// }
// if (
//   userFormData.employee_designation &&
//   !dropdownOptions.designations.includes(userFormData.employee_designation)
// ) {
//   userFormData.employee_other_designation = userFormData.employee_designation;
//   userFormData.employee_designation = "Other";
// }
// if (
//   userFormData.employee_division &&
//   !dropdownOptions.divisions.includes(userFormData.employee_division)
// ) {
//   userFormData.employee_other_division = userFormData.employee_division;
//   userFormData.employee_division = "Other";
// }
// if (
//   userFormData.employee_subdivision &&
//   !dropdownOptions.subdivisions.includes(userFormData.employee_subdivision)
// ) {
//   userFormData.employee_other_subdivision = userFormData.employee_subdivision;
//   userFormData.employee_subdivision = "Other";
// }


// setFormData(userFormData);
// setShowEditModal(true);
//   }
//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     if (formData.password && formData.password !== formData.confirm_password) {
//       Swal.fire("Error", "Passwords do not match!", "error");
//       return;
//     }
//     if (
//       formData.email !== formData.confirm_email &&
//       currentUser?.email !== formData.email
//     ) {
//       Swal.fire("Error", "Emails do not match for confirmation!", "error");
//       return;
//     }
//     setFormLoading(true);
//     const payload = preparePayload(formData);
//     delete payload.id;

//     try {
//       await axios.patch(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-update/${currentUser.id}/`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setFormLoading(false);
//       setShowEditModal(false);
//       setFormData(initialFormData);
//       fetchUsers();
//       Swal.fire("Success", "User updated successfully!", "success");
//     } catch (error) {
//       setFormLoading(false);
//       console.error(
//         "Failed to update user:",
//         error.response ? error.response.data : error
//       );
//       Swal.fire(
//         "Error",
//         `Failed to update user: ${
//           error.response?.data?.detail ||
//           error.response?.data?.message ||
//           Object.values(error.response?.data || {}).join(", ") ||
//           "Server error"
//         }`,
//         "error"
//       );
//     }
//   };

//   const handleDeleteClick = (user) => {
//     setCurrentUser(user);
//     setShowDeleteModal(true);
//   };

//   const handleDeleteConfirm = async () => {
//     setFormLoading(true);
//     try {
//       await axios.delete(
//         `https://tdtlworld.com/dss-kaas-backend/lms/users-delete/${currentUser.id}/`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setFormLoading(false);
//       setShowDeleteModal(false);
//       fetchUsers();
//       Swal.fire("Deleted!", "User has been deleted.", "success");
//     } catch (error) {
//       setFormLoading(false);
//       console.error("Failed to delete user:", error);
//       Swal.fire("Error", "Failed to delete user.", "error");
//     }
//   };

//   // Styles (unchanged)
//   const modalBackdropStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//   };
//   const modalContentStyle = {
//     backgroundColor: "white",
//     borderRadius: "10px",
//     padding: "0px",
//     width: "clamp(500px, 80vw, 900px)",
//     maxWidth: "95%",
//     maxHeight: "90vh",
//     display: "flex",
//     flexDirection: "column",
//   };
//   const modalHeaderStyle = {
//     padding: "15px 20px",
//     borderBottom: "1px solid #eee",
//     background: "linear-gradient(90deg, #800080, #ffa500)",
//     position: "sticky",
//     textAlign: "center",
//     top: 0,
//     zIndex: 10,
//     color: "white",
//     fontWeight: 10,
//   };
//   const modalBodyStyle = { padding: "20px", overflowY: "auto", flexGrow: 1 };
//   const modalFooterStyle = {
//     padding: "15px 20px",
//     borderTop: "1px solid #eee",
//     textAlign: "right",
//     backgroundColor: "white",
//     position: "sticky",
//     bottom: 0,
//     zIndex: 1,
//   };
//   const inputStyle = {
//     width: "100%",
//     padding: "10px",
//     border: "1px solid #ddd",
//     borderRadius: "5px",
//     boxSizing: "border-box",
//   };
//   const labelStyle = {
//     display: "block",
//     marginBottom: "5px",
//     fontWeight: "100",
//   };
//   const sectionStyle = {
//     borderBottom: "1px solid #eee",
//     paddingBottom: "8px",
//     marginBottom: "15px",
//     fontSize: "1.1rem",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   };
//   const gridContainerStyle = {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//     gap: "15px",
//     marginBottom: "20px",
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setShowExcelData(false); 

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//       const jsonData = XLSX.utils.sheet_to_json(firstSheet);

//       const requiredFields = [
//         "first_name",
//         "last_name",
//         "email",
//         "mobile_number",
//         "address_line1",
//         "country",
//         "state_address",
//         "district",
//         "pin_code",
//         "occupation",
//         "education",
//       ];

//       const validatedData = jsonData.map((row, index) => {
//         const errors = [];

//         requiredFields.forEach((field) => {
//           if (!row[field]) {
//             errors.push(`Missing ${field} in row ${index + 2}`);
//           }
//         });

//         if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
//           errors.push(`Invalid email format in row ${index + 2}`);
//         }

//         return {
//           first_name: row.first_name || "",
//           middle_name: row.middle_name || "",
//           last_name: row.last_name || "",
//           email: row.email || "",
//           mobile_number: row.mobile_number || "",
//           role: "Student",
//           role_id: 2,
//           address_line1: row.address_line1 || "",
//           village: row.village || "",
//           tehsil: row.tehsil || "",
//           district: row.district || "",
//           state_address: row.state_address || "",
//           country: row.country || "",
//           pin_code: row.pin_code || "",
//           occupation: row.occupation || "",
//           education: row.education || "",
//           degree: row.degree || "",
//           farm_type: row.farm_type || "",
//           farmer_agriculture_type: row.farmer_agriculture_type || "",
//           farmer_livestock_type: row.farmer_livestock_type || "",
//           farmer_poultry_type: row.farmer_poultry_type || "",
//           farmer_aquaculture_type: row.farmer_aquaculture_type || "",
//           doctor_specialization: row.doctor_specialization || "",
//           business_nature: row.business_nature || "",
//           business_company_name: row.business_company_name || "",
//           business_company_address: row.business_company_address || "",
//           service_company_name: row.service_company_name || "",
//           service_designation: row.service_designation || "",
//           consultant_area: row.consultant_area || "",
//           employee_id: row.employee_id || "",
//           employee_department: row.employee_department || "",
//           employee_designation: row.employee_designation || "",
//           employee_division: row.employee_division || "",
//           employee_subdivision: row.employee_subdivision || "",
//           employee_headquarter: row.employee_headquarter || "",
//           password: row.employee_password || "",
//           confirm_password: row.employee_c_password ||"",
//           _errors: errors.length > 0 ? errors : null,
//           _isValid: errors.length === 0,
//         };
//       });

//       setExcelData(validatedData);
//       setShowPreview(true);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   const importUsersFromExcel = async () => {
//     setFormLoading(true);
//     setUploadProgress(0);

//     const validUsers = excelData.filter((user) => user._isValid);
//     const totalUsers = validUsers.length;
//     let successCount = 0;
//     const importedUsers = [];
//     const errorMessages = [];

//     for (let i = 0; i < validUsers.length; i++) {
//       const user = validUsers[i];
//       try {
//         const payload = { ...user };
//         delete payload._errors;
//         delete payload._isValid;
//         delete payload.confirm_password;

//         payload.role_id = 2;

//         await axios.post(
//           "https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/",
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         successCount++;
//         importedUsers.push(
//           `${user.first_name} ${user.last_name} (${user.email})`
//         );
//       }
//       catch (error) {
//   const data = error.response?.data;
//   let errorText = "Server error";

//   if (typeof data === "string") {
//     errorText = data;
//   } else if (data?.message) {
//     errorText = data.message;
//   } else if (data?.error) {
//     errorText = data.error;
//   } else if (typeof data === "object") {
//     // Handle field-specific errors (e.g., {"password": ["This field is required."]})
//     const fieldErrors = Object.entries(data).flatMap(([field, errors]) => {
//       return errors.map((err) => `${field}:${err.toLowerCase()}`);
//     });
//     errorText = fieldErrors.join(", ");
//   } else if (error.message) {
//     errorText = error.message;
//   }

//   errorMessages.push({
//     user: `${user.first_name} ${user.last_name}`,
//     error: errorText,
//   });
// }


//       setUploadProgress(Math.floor(((i + 1) / totalUsers) * 100));
//     }

//     setFormLoading(false);
//     setImportResults({
//       total: validUsers.length,
//       success: successCount,
//       failed: validUsers.length - successCount,
//       importedUsers,
//       errorMessages,
//     });

//     // Refresh user list
//     fetchUsers();
//   };

//   const downloadTemplate = () => {
//     // Create template with all required fields
//     const templateData = [
//       {
//         first_name: "John",
//         middle_name: "",
//         last_name: "Doe",
//         email: "john.doe@example.com",
//         mobile_number: "9876543210",
//         role: "Student",
//         address_line1: "123 Main St",
//         village: "",
//         tehsil: "",
//         district: "Mumbai",
//         state_address: "Maharashtra",
//         country: "India",
//         pin_code: "400001",
//         occupation: "Farmer",
//         education: "Graduate",
//         degree: "B.Sc Agriculture",
//         farm_type: "Agriculture",
// farm_type: "Agriculture",
//     farmer_agriculture_type: "Crop farming",
//     farmer_livestock_type: "",
//     farmer_poultry_type: "",
//     farmer_aquaculture_type: "",
    
//     // Professional Fields
//     doctor_specialization: "",
//     business_nature: "",
//     business_company_name: "",
//     business_company_address: "",
//     service_company_name: "",
//     service_designation: "",
//     consultant_area: "",
    
//     // Employee Fields
//     employee_id: "",
//     employee_department: "",
//     employee_designation: "",
//     employee_division: "",
//     employee_subdivision:"",
//     employee_headquarter: "",
    
//     // Password Fields
//     password: "sample@123",
//     confirm_password: "sample@123",
            
//       },
//     ];

//     // Add all other possible fields as empty to show structure
//     const allFields = Object.keys(initialFormData).filter(
//       (f) => !["confirm_email", "confirm_password", "password"].includes(f)
//     );
//     allFields.forEach((field) => {
//       if (!templateData[0][field]) {
//         templateData[0][field] = "";
//       }
//     });

//     const ws = XLSX.utils.json_to_sheet(templateData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "UsersTemplate");
//     XLSX.writeFile(wb, "User_Import_Example.xlsx");
//   };

//   const closeImportResults = () => {
//     setImportResults(null);
//     setShowUploadModal(false);
//     setExcelData([]);
//     setShowPreview(false);
//     setUploadProgress(0);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1 style={{ marginBottom: "20px", color: "#333" }}>User Management</h1>

//       <Card>
//         {/* Search and Filter UI (unchanged) */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "15px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               position: "relative",
//               minWidth: "250px",
//               flexGrow: 1,
//             }}
//           >
//             <FaSearch
//               style={{ position: "absolute", left: "10px", color: "#888" }}
//             />
//             <input
//               type="text"
//               placeholder="Search by name, email, mobile, occupation..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: "10px 10px 10px 35px",
//                 border: "1px solid #ddd",
//                 borderRadius: "5px",
//                 width: "100%",
//               }}
//             />
//           </div>
//           <div
//             style={{
//               display: "flex",
//               gap: "10px",
//               flexWrap: "wrap",
//               alignItems: "center",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//               <FaFilter style={{ color: "#888" }} />
//               <select
//                 value={filterRole}
//                 onChange={(e) => setFilterRole(e.target.value)}
//                 style={{
//                   padding: "10px",
//                   border: "1px solid #ddd",
//                   borderRadius: "5px",
//                 }}
//               >
//                 <option value="">All Roles</option>
//                 {Object.keys(roleToIdMap).map((roleName) => (
//                   <option key={roleName} value={roleName}>
//                     {roleName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <button
//               onClick={() => setShowUploadModal(true)}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 padding: "10px 15px",
//                 background: `linear-gradient(45deg, #4CAF50, #2E7D32)`,
//                 color: "white",
//                 border: "none",
//                 borderRadius: "5px",
//                 cursor: "pointer",
//                 fontSize: "14px",
//               }}
//             >
//               <FaFileExcel />
//               Import Users
//             </button>
//             <button
//               onClick={() => {
//                 setFormData(initialFormData);
//                 setShowAddModal(true);
//               }}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 padding: "10px 15px",
//                 background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//                 color: "white",
//                 border: "none",
//                 borderRadius: "5px",
//                 cursor: "pointer",
//                 fontSize: "14px",
//               }}
//             >
//               <FaUserPlus />
//               Add User
//             </button>
//           </div>
//         </div>
//         {loading ? (
//           <p>Loading users...</p>
//         ) : (
//           <Table
//             columns={columns}
//             data={filteredUsers}
//             pagination={true}
//             itemsPerPage={10}
//           />
//         )}
//       </Card>
//       {importResults && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: "500px" }}>
//             <div style={modalHeaderStyle}>
//               <h2 style={{ margin: 0 }}>Import Results</h2>
//             </div>
//             <div style={modalBodyStyle}>
//               <div style={{ marginBottom: "20px" }}>
//                 <p style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
//                   Import completed: {importResults.success} of{" "}
//                   {importResults.total} users imported successfully
//                 </p>

//                 {importResults.success > 0 && (
//                   <div style={{ marginTop: "15px" }}>
//                     <h4 style={{ marginBottom: "10px" }}>Imported Users:</h4>
//                     <div
//                       style={{
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         border: "1px solid #eee",
//                         borderRadius: "5px",
//                         padding: "10px",
//                       }}
//                     >
//                       {importResults.importedUsers.map((user, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             padding: "8px 0",
//                             borderBottom:
//                               index < importResults.importedUsers.length - 1
//                                 ? "1px solid #f0f0f0"
//                                 : "none",
//                           }}
//                         >
//                           {user}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {importResults.failed > 0 && (
//                   <div style={{ marginTop: "15px" }}>
//                     <h4 style={{ marginBottom: "10px", color: "#ff5370" }}>
//                       Failed to import {importResults.failed} users
//                     </h4>
//                     <div
//                       style={{
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         border: "1px solid #eee",
//                         borderRadius: "5px",
//                         padding: "10px",
//                       }}
//                     >
//                       {importResults.errorMessages.map((error, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             padding: "8px 0",
//                             borderBottom:
//                               index < importResults.errorMessages.length - 1
//                                 ? "1px solid #f0f0f0"
//                                 : "none",
//                           }}
//                         >
//                           <strong>{error.user}:</strong> {error.error}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div style={modalFooterStyle}>
//               <button
//                 onClick={closeImportResults}
//                 style={{
//                   padding: "8px 15px",
//                   background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Upload Modal */}
//       {showUploadModal && !importResults && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: "500px" }}>
//             <div style={modalHeaderStyle}>
//               <h2 style={{ margin: 0 }}>Import Users from Excel</h2>
//             </div>
//             <div style={modalBodyStyle}>
//               {!showPreview ? (
//                 <>
//                   <p>
//                     Upload an Excel file with user data.{" "}
//                     <button
//                       onClick={downloadTemplate}
//                       style={{
//                         color: "#7366ff",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         textDecoration: "underline",
//                       }}
//                     >
//                       Download Template
//                     </button>
//                   </p>

//                   <div
//                     style={{
//                       border: "2px dashed #ddd",
//                       padding: "20px",
//                       textAlign: "center",
//                       margin: "20px 0",
//                       borderRadius: "5px",
//                     }}
//                   >
//                     <input
//                       type="file"
//                       id="excelUpload"
//                       accept=".xlsx, .xls"
//                       onChange={handleFileUpload}
//                       style={{ display: "none" }}
//                     />
//                     <label htmlFor="excelUpload" style={{ cursor: "pointer" }}>
//                       <FaFileExcel
//                         style={{
//                           fontSize: "48px",
//                           color: "#2E7D32",
//                           marginBottom: "10px",
//                         }}
//                       />
//                       <p>Click to upload Excel file</p>
//                       <p style={{ fontSize: "0.8rem", color: "#666" }}>
//                         .xlsx or .xls files only
//                       </p>
//                     </label>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       marginBottom: "15px",
//                     }}
//                   >
//                     <h3 style={{ margin: 0 }}>
//                       Preview Data ({excelData.length} users)
//                     </h3>
//                     <div>
//                       <span
//                         style={{
//                           color: excelData.some((u) => !u._isValid)
//                             ? "#ff5370"
//                             : "#2E7D32",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {excelData.filter((u) => u._isValid).length} valid,{" "}
//                         {excelData.filter((u) => !u._isValid).length} with
//                         errors
//                       </span>
//                     </div>
//                   </div>
//                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
//               <button
//                 onClick={() => setShowExcelData(!showExcelData)}
//                 style={{
//                   padding: '8px 15px',
//                   background: '#7366ff',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px'
//                 }}
//               >
//                 <FaEye />
//                 {showExcelData ? 'Hide Excel' : 'View Excel'}
//               </button>
//             </div>

//                   <div
//                     style={{
//                       maxHeight: "300px",
//                       overflowY: "auto",
//                       marginBottom: "20px",
//                       border: "1px solid #eee",
//                       borderRadius: "5px",
//                     }}
//                   >
//                     <table
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead
//                         style={{
//                           position: "sticky",
//                           top: 0,
//                           background: "#f8f9fa",
//                         }}
//                       >
//                         <tr>
//                           <th
//                             style={{
//                               padding: "8px",
//                               borderBottom: "1px solid #ddd",
//                               textAlign: "left",
//                             }}
//                           >
//                             Name
//                           </th>
//                           <th
//                             style={{
//                               padding: "8px",
//                               borderBottom: "1px solid #ddd",
//                               textAlign: "left",
//                             }}
//                           >
//                             Email
//                           </th>
//                           <th
//                             style={{
//                               padding: "8px",
//                               borderBottom: "1px solid #ddd",
//                               textAlign: "left",
//                             }}
//                           >
//                             Status
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {excelData.map((user, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               background: user._isValid
//                                 ? "transparent"
//                                 : "rgba(255, 83, 112, 0.1)",
//                             }}
//                           >
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 borderBottom: "1px solid #eee",
//                               }}
//                             >
//                               {user.first_name} {user.last_name}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 borderBottom: "1px solid #eee",
//                               }}
//                             >
//                               {user.email}
//                             </td>
//                             <td
//                               style={{
//                                 padding: "8px",
//                                 borderBottom: "1px solid #eee",
//                               }}
//                             >
//                               {user._isValid ? (
//                                 <span style={{ color: "#2E7D32" }}>
//                                   ✓ Valid
//                                 </span>
//                               ) : (
//                                 <div>
//                                   <span style={{ color: "#ff5370" }}>
//                                     ✗ Errors:
//                                   </span>
//                                   <ul
//                                     style={{
//                                       margin: "5px 0 0 0",
//                                       paddingLeft: "20px",
//                                     }}
//                                   >
//                                     {user._errors.map((err, i) => (
//                                       <li
//                                         key={i}
//                                         style={{ fontSize: "0.8rem" }}
//                                       >
//                                         {err}
//                                       </li>
//                                     ))}
//                                   </ul>
//                                 </div>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>

//                   {uploadProgress > 0 && (
//                     <div style={{ marginBottom: "15px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           marginBottom: "5px",
//                         }}
//                       >
//                         <span>Upload Progress:</span>
//                         <span>{uploadProgress}%</span>
//                       </div>
//                       <div
//                         style={{
//                           height: "10px",
//                           background: "#eee",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         <div
//                           style={{
//                             height: "100%",
//                             width: `${uploadProgress}%`,
//                             background: "#4CAF50",
//                             borderRadius: "5px",
//                           }}
//                         ></div>
//                       </div>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//             <div style={modalFooterStyle}>
//               <button
//                 onClick={() => {
//                   setShowUploadModal(false);
//                   setExcelData([]);
//                   setShowPreview(false);
//                   setUploadProgress(0);
//                 }}
//                 style={{
//                   padding: "8px 15px",
//                   background: "#6c757d",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   marginRight: "10px",
//                 }}
//               >
//                 Cancel
//               </button>
//               {showPreview && (
                
//                 <button
//                   onClick={importUsersFromExcel}
//                   disabled={
//                     formLoading ||
//                     excelData.filter((u) => u._isValid).length === 0
//                   }
//                   style={{
//                     padding: "8px 15px",
//                     background: `linear-gradient(45deg, #4CAF50, #2E7D32)`,
//                     color: "white",
//                     border: "none",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                     opacity:
//                       excelData.filter((u) => u._isValid).length === 0
//                         ? 0.5
//                         : 1,
//                   }}
//                 >
//                   {formLoading ? "Importing..." : "Import Valid Users"}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}


// {showExcelData && (
//   <div style={modalBackdropStyle}>
//     <div style={{ ...modalContentStyle, width: '80vw', maxWidth: '1200px', height: '80vh' }}>
//       <div style={modalHeaderStyle}>
//         <h2 style={{ margin: 0 }}>Excel Data Preview</h2>
//       </div>
//       <div style={{ ...modalBodyStyle, overflow: 'auto' }}>
//         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//           <thead style={{ position: 'sticky', top: 0, background: '#f8f9fa' }}>
//             <tr>
//               {excelData.length > 0 && Object.keys(excelData[0]).map((key) => (
//                 !key.startsWith('_') && (
//                   <th 
//                     key={key}
//                     style={{
//                       padding: '8px',
//                       borderBottom: '1px solid #ddd',
//                       textAlign: 'left',
//                       position: 'sticky',
//                       top: 0,
//                       background: '#f8f9fa'
//                     }}
//                   >
//                     {key}
//                   </th>
//                 )
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {excelData.map((row, rowIndex) => (
//               <tr 
//                 key={rowIndex}
//                 style={{
//                   background: row._isValid ? 'transparent' : 'rgba(255, 83, 112, 0.1)'
//                 }}
//               >
//                 {Object.entries(row).map(([key, value]) => (
//                   !key.startsWith('_') && (
//                     <td
//                       key={key}
//                       style={{
//                         padding: '8px',
//                         borderBottom: '1px solid #eee',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         maxWidth: '200px'
//                       }}
//                     >
//                       {typeof value === 'object' ? JSON.stringify(value) : value}
//                     </td>
//                   )
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div style={modalFooterStyle}>
//         <button
//           onClick={() => setShowExcelData(false)}
//           style={{
//             padding: '8px 15px',
//             background: '#7366ff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '5px',
//             cursor: 'pointer'
//           }}
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//       {(showAddModal || showEditModal) && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <div style={modalHeaderStyle}>
//               <h2
//                 style={{ margin: 0, fontSize: "1.5rem", alignItems: "center" }}
//               >
//                 {showAddModal ? "Add New User" : "Edit User"}
//               </h2>
//             </div>

//             <form
//               onSubmit={showAddModal ? handleAddSubmit : handleEditSubmit}
//               style={modalBodyStyle}
//             >
//               {/* Personal Info, Credentials sections are unchanged */}
//               <h3 style={sectionStyle}>Personal Information</h3>
//               <div style={gridContainerStyle}>
//                 <div>
//                   <label style={labelStyle}>First Name*</label>
//                   <input
//                     type="text"
//                     name="first_name"
//                     value={formData.first_name}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Middle Name</label>
//                   <input
//                     type="text"
//                     name="middle_name"
//                     value={formData.middle_name}
//                     onChange={handleInputChange}
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Last Name*</label>
//                   <input
//                     type="text"
//                     name="last_name"
//                     value={formData.last_name}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Mobile Number *</label>
//                   <input
//                     type="text"
//                     name="mobile_number"
//                     value={formData.mobile_number}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Role*</label>
//                   <select
//                     name="role"
//                     value={formData.role}
//                     onChange={handleInputChange}
//                     style={inputStyle}
//                     required
//                   >
//                     {Object.keys(roleToIdMap).map((roleName) => (
//                       <option key={roleName} value={roleName}>
//                         {roleName}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <h3 style={sectionStyle}>Login Credentials</h3>
//               <div style={gridContainerStyle}>
//                 <div>
//                   <label style={labelStyle}>Email*</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Confirm Email*</label>
//                   <input
//                     type="email"
//                     name="confirm_email"
//                     value={formData.confirm_email}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>
//                     Password
//                     {showAddModal ? "*" : " (Leave blank to keep unchanged)"}
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleInputChange}
//                     required={showAddModal}
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>
//                     Confirm Password{showAddModal ? "*" : ""}
//                   </label>
//                   <input
//                     type="password"
//                     name="confirm_password"
//                     value={formData.confirm_password}
//                     onChange={handleInputChange}
//                     required={showAddModal}
//                     style={inputStyle}
//                   />
//                 </div>
//               </div>

//               <h3 style={sectionStyle}>Address Information</h3>
//               <div style={gridContainerStyle}>
//                 <div>
//                   <label style={labelStyle}>Address Line 1*</label>
//                   <input
//                     type="text"
//                     name="address_line1"
//                     value={formData.address_line1}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>

//                 {/* CSC-LIB: Updated JSX for dynamic dropdowns */}
//                 <div>
//                   <label style={labelStyle}>Country*</label>
//                   <select
//                     name="country"
//                     value={formData.countryCode}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   >
//                     <option value="">Select Country</option>
//                     {countries.map((country) => (
//                       <option key={country.isoCode} value={country.isoCode}>
//                         {country.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={labelStyle}>State*</label>
//                   <select
//                     name="state_address"
//                     value={formData.stateCode}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                     disabled={!formData.countryCode}
//                   >
//                     <option value="">Select State</option>
//                     {availableStates.map((state) => (
//                       <option key={state.isoCode} value={state.isoCode}>
//                         {state.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={labelStyle}>District / City*</label>
//                   <select
//                     name="district"
//                     value={formData.district}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                     disabled={!formData.stateCode}
//                   >
//                     <option value="">Select District / City</option>
//                     {availableDistricts.map((district) => (
//                       <option key={district.name} value={district.name}>
//                         {district.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 {/* CSC-LIB: Tehsil and Village are now text inputs */}
//                 <div>
//                   <label style={labelStyle}>Tehsil / Taluka</label>
//                   <input
//                     type="text"
//                     name="tehsil"
//                     value={formData.tehsil}
//                     onChange={handleInputChange}
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Village</label>
//                   <input
//                     type="text"
//                     name="village"
//                     value={formData.village}
//                     onChange={handleInputChange}
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Pin Code*</label>
//                   <input
//                     type="text"
//                     name="pin_code"
//                     value={formData.pin_code}
//                     onChange={handleInputChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//               </div>

//               {/* All other occupation-specific sections are unchanged */}
//               <h3 style={sectionStyle}>Occupation and Education</h3>
//               <div style={gridContainerStyle}>
//                 <div>
//               <label style={labelStyle}>Occupation*</label>
//               {renderOccupationDropdown()}
//             </div>
//                <div>
//               <label style={labelStyle}>Education*</label>
//               {renderEducationDropdown()}
//             </div>
//                 <div>
//                   <label style={labelStyle}>Degree</label>
//                   <input
//                     type="text"
//                     name="degree"
//                     value={formData.degree}
//                     onChange={handleInputChange}
//                     style={inputStyle}
//                   />
//                 </div>
//               </div>
//               {formData.occupation === "Farmer" && (
//                 <>
//                   <h3 style={sectionStyle}>Farmer Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Farm Type*</label>
//                       <select
//                         name="farm_type"
//                         value={formData.farm_type}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       >
//                         <option value="">Select Farm Type</option>
//                         {farmTypeOptions.map((type) => (
//                           <option key={type} value={type}>
//                             {type}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     {formData.farm_type === "Agriculture" && (
//                       <div>
//                         <label style={labelStyle}>Agriculture Type*</label>
//                         <select
//                           name="farmer_agriculture_type"
//                           value={formData.farmer_agriculture_type}
//                           onChange={handleInputChange}
//                           required
//                           style={inputStyle}
//                         >
//                           <option value="">Select Agriculture Type</option>
//                           {agricultureTypeOptions.map((type) => (
//                             <option key={type} value={type}>
//                               {type}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                     {formData.farm_type === "Livestock" && (
//                       <div>
//                         <label style={labelStyle}>Livestock Type*</label>
//                         <select
//                           name="farmer_livestock_type"
//                           value={formData.farmer_livestock_type}
//                           onChange={handleInputChange}
//                           required
//                           style={inputStyle}
//                         >
//                           <option value="">Select Livestock Type</option>
//                           {livestockTypeOptions.map((type) => (
//                             <option key={type} value={type}>
//                               {type}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                     {formData.farm_type === "Poultry" && (
//                       <div>
//                         <label style={labelStyle}>Poultry Type*</label>
//                         <select
//                           name="farmer_poultry_type"
//                           value={formData.farmer_poultry_type}
//                           onChange={handleInputChange}
//                           required
//                           style={inputStyle}
//                         >
//                           <option value="">Select Poultry Type</option>
//                           {poultryTypeOptions.map((type) => (
//                             <option key={type} value={type}>
//                               {type}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                     {formData.farm_type === "Aquaculture" && (
//                       <div>
//                         <label style={labelStyle}>Aquaculture Type*</label>
//                         <select
//                           name="farmer_aquaculture_type"
//                           value={formData.farmer_aquaculture_type}
//                           onChange={handleInputChange}
//                           required
//                           style={inputStyle}
//                         >
//                           <option value="">Select Aquaculture Type</option>
//                           {aquacultureTypeOptions.map((type) => (
//                             <option key={type} value={type}>
//                               {type}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                   </div>
//                 </>
//               )}
//               {formData.occupation === "Doctor" && (
//                 <>
//                   <h3 style={sectionStyle}>Doctor Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Specialization*</label>
//                       <select
//                         name="doctor_specialization"
//                         value={formData.doctor_specialization}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       >
//                         <option value="">Select Specialization</option>
//                         {doctorSpecializationOptions.map((spec) => (
//                           <option key={spec} value={spec}>
//                             {spec}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </>
//               )}
//               {formData.occupation === "Business" && (
//                 <>
//                   <h3 style={sectionStyle}>Business Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Nature of Business*</label>
//                       <select
//                         name="business_nature"
//                         value={formData.business_nature}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       >
//                         <option value="">Select Nature</option>
//                         {businessNatureOptions.map((nature) => (
//                           <option key={nature} value={nature}>
//                             {nature}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Company Name*</label>
//                       <input
//                         type="text"
//                         name="business_company_name"
//                         value={formData.business_company_name}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Company Address*</label>
//                       <input
//                         type="text"
//                         name="business_company_address"
//                         value={formData.business_company_address}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}
//               {formData.occupation === "Service" && (
//                 <>
//                   <h3 style={sectionStyle}>Service Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Company Name*</label>
//                       <input
//                         type="text"
//                         name="service_company_name"
//                         value={formData.service_company_name}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       />
//                     </div>
//                       <div>
//                 <label style={labelStyle}>Designation*</label>
//                 {renderDesignationDropdown()}
//                 {formData.service_designation === "Other" && (
//                   <input
//                     type="text"
//                     name="service_designation"
//                     value={formData.service_designation}
//                     onChange={handleInputChange}
//                     placeholder="Enter Designation"
//                     required
//                     style={{ ...inputStyle, marginTop: "5px" }}
//                   />
//                 )}
//               </div>
//                   </div>
//                 </>
//               )}
//               {formData.occupation === "Consultant" && (
//                 <>
//                   <h3 style={sectionStyle}>Consultant Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Consultant Area*</label>
//                       <select
//                         name="consultant_area"
//                         value={formData.consultant_area}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       >
//                         <option value="">Select Area</option>
//                         {consultantAreaOptions.map((area) => (
//                           <option key={area} value={area}>
//                             {area}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </>
//               )}
//               {formData.occupation === "Company employee" && (
//                 <>
//                   <h3 style={sectionStyle}>Employee Details</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Employee ID</label>
//                       <input
//                         type="text"
//                         name="employee_id"
//                         value={formData.employee_id}
//                         onChange={handleInputChange}
//                         style={inputStyle}
//                         required
//                       />
//                     </div>
//                      <div>
//                 <label style={labelStyle}>Department*</label>
//                 {renderDepartmentDropdown()}
//                 {formData.employee_department === "Other" && (
//                   <input
//                     type="text"
//                     name="employee_other_department"
//                     value={formData.employee_other_department}
//                     onChange={handleInputChange}
//                     placeholder="Enter Department"
//                     required
//                     style={{ ...inputStyle, marginTop: "5px" }}
//                   />
//                 )}
//               </div>
//                     <div>
//                 <label style={labelStyle}>Designation*</label>
//                 {renderDesignationDropdown()}
//                 {formData.employee_designation === "Other" && (
//                   <input
//                     type="text"
//                     name="employee_other_designation"
//                     value={formData.employee_other_designation}
//                     onChange={handleInputChange}
//                     placeholder="Enter Designation"
//                     required
//                     style={{ ...inputStyle, marginTop: "5px" }}
//                   />
//                 )}
//               </div>
//                      <div>
//                 <label style={labelStyle}>Division*</label>
//                 {renderDivisionDropdown()}
//                 {formData.employee_division === "Other" && (
//                   <input
//                     type="text"
//                     name="employee_other_division"
//                     value={formData.employee_other_division}
//                     onChange={handleInputChange}
//                     placeholder="Enter Division"
                  
//                     style={{ ...inputStyle, marginTop: "5px" }}
//                   />
//                 )}
//               </div>
//               <div>
//                 <label style={labelStyle}>SubDivision*</label>
//                 {renderSubDivisionDropdown()}
//                 {formData.employee_subdivision === "Other" && (
//                   <input
//                     type="text"
//                     name="employee_other_subdivision"
//                     value={formData.employee_other_subdivision}
//                     onChange={handleInputChange}
//                     placeholder="Enter SubDivision"
                    
//                     style={{ ...inputStyle, marginTop: "5px" }}
//                   />
//                 )}
//               </div>
//                     <div>
//                       <label style={labelStyle}>Headquarter</label>
//                       <input
//                         type="text"
//                         name="employee_headquarter"
//                         value={formData.employee_headquarter}
//                         onChange={handleInputChange}
//                         style={inputStyle}
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}
//             </form>
//             <div style={modalFooterStyle}>
//               <button
//                 onClick={() => {
//                   setShowAddModal(false);
//                   setShowEditModal(false);
//                   setFormData(initialFormData);
//                 }}
//                 style={{
//                   padding: "8px 15px",
//                   background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   marginRight: "10px",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={showAddModal ? handleAddSubmit : handleEditSubmit}
//                 disabled={formLoading}
//                 style={{
//                   padding: "8px 15px",
//                   background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 {formLoading
//                   ? "Processing..."
//                   : showAddModal
//                   ? "Add User"
//                   : "Update User"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showDeleteModal && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: "400px" }}>
//             <div style={modalHeaderStyle}>
//               <h2 style={{ margin: 0 }}>Confirm Delete</h2>
//             </div>
//             <div style={{ ...modalBodyStyle, textAlign: "center" }}>
//               <p>
//                 Are you sure you want to delete user:{" "}
//                 <strong>{currentUser?.name}</strong>?
//               </p>
//               <p>This action cannot be undone.</p>
//             </div>
//             <div style={modalFooterStyle}>
//               <button
//                 onClick={() => setShowDeleteModal(false)}
//                 style={{
//                   padding: "8px 15px",
//                   background: "#6c757d",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   marginRight: "10px",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteConfirm}
//                 disabled={formLoading}
//                 style={{
//                   padding: "8px 15px",
//                   background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 {formLoading ? "Deleting..." : "Delete"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserManagement;
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"; // Add this import
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { useColorMode } from "../../../theme/ThemeContext";
import { useAuth } from "../../../utils/AuthContext";
import {
  FaEdit,
  FaTrash,
  FaUserPlus,
  FaSearch,
  FaFilter,
  FaFileExcel,
  FaEye,
} from "react-icons/fa";
// CSC-LIB: Import the library functions
import { Country, State, City } from "country-state-city";
import Card from "../admincomponents/Card"; // Assuming Card component path
import Table from "../admincomponents/Table"; // Assuming Table component path

const GOLD = "#D4AF37";

// Token is handled inside the component via AuthContext


const farmTypeOptions = ["Agriculture", "Livestock", "Poultry", "Aquaculture"];
const agricultureTypeOptions = ["Crop farming", "Horticulture", "Floriculture"];
const livestockTypeOptions = ["Dairy", "Sheep & Goat", "Swine"];
const poultryTypeOptions = ["Layer", "Broiler"];
const aquacultureTypeOptions = ["Shrimp", "Fish"];
const doctorSpecializationOptions = ["Small Animal", "Ruminants"];
const businessNatureOptions = ["Manufacturing", "Treading"];
const consultantAreaOptions = ["Agriculture", "Dairy", "Swine", "Poultry"];


// const divisionOptions = [
//   "Livestock",
//   "Small Ruminant",
//   "Companion",
//   "Poultry",
//   "Aqua",
//   "Other",
// ];

const initialFormData = {
  first_name: "",
  middle_name: "",
  last_name: "",
  email: "",
  confirm_email: "",
  password: "",
  confirm_password: "",
  mobile_number: "",
  role: "Student",
  role_id: 2,
  address_line1: "",
  village: "",
  tehsil: "",
  district: "",
  state_address: "",
  country: "",
  pin_code: "",
  // CSC-LIB: Add codes for the library to use
  countryCode: "",
  stateCode: "",
  occupation: "Farmer",
  education: "Secondary",
  degree: "",
  farm_type: "",
  farmer_agriculture_type: "",
  farmer_livestock_type: "",
  farmer_poultry_type: "",
  farmer_aquaculture_type: "",
  doctor_specialization: "",
  business_nature: "",
  business_company_name: "",
  business_company_address: "",
  service_company_name: "",
  service_designation: "",
  consultant_area: "",
  employee_id: "",
  employee_department: "",
  employee_designation: "",
  employee_division: "",
  employee_subdivision:"",
  employee_headquarter: "",
  employee_other_department: "",
  employee_other_designation: "",
  employee_other_division: "",
  employee_other_subdivision:"",
};

const roleToIdMap = {
  Student: 2,
  Instructor: 3,
  Trainer: 4,
  Admin: 1,
};
const idToRoleMap = {
  2: "Student",
  3: "Instructor",
  4: "Trainer",
  1: "Admin",
};

const UserManagement = () => {
  const theme = useTheme();
  const { mode } = useColorMode();
  const { token } = useAuth();
  const isDark = theme.palette.mode === "dark";

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterRole, setFilterRole] = useState("");
  const [formData, setFormData] = useState(initialFormData);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showPreview, setShowPreview] = useState(false);
  const [importResults, setImportResults] = useState(null);
  const [showExcelData, setShowExcelData] = useState(false);
  const [countries, setCountries] = useState([]);
  const [availableStates, setAvailableStates] = useState([]);
  const [availableDistricts, setAvailableDistricts] = useState([]); // Will hold cities
  const [filteredSubdivisions, setFilteredSubdivisions] = useState([]);

  const [dropdownOptions, setDropdownOptions] = useState({
    education: [],
    occupation: [],
    designations: [],
    divisions: [],
    departments: [],
    subdivisions:[],
  });

  
  // CSC-LIB: Load all countries on component mount
  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  // CSC-LIB: Update available states when country changes
  useEffect(() => {
    const states = formData.countryCode
      ? State.getStatesOfCountry(formData.countryCode)
      : [];
    setAvailableStates(states);
    // When country changes, reset state and district
    if (!states.find((s) => s.isoCode === formData.stateCode)) {
      setFormData((prev) => ({
        ...prev,
        state_address: "",
        stateCode: "",
        district: "",
      }));
    }
  }, [formData.countryCode]);

  // CSC-LIB: Update available districts (cities) when state changes
  useEffect(() => {
    const districts =
      formData.countryCode && formData.stateCode
        ? City.getCitiesOfState(formData.countryCode, formData.stateCode)
        : [];
    setAvailableDistricts(districts);
    // When state changes, reset district
    if (!districts.find((d) => d.name === formData.district)) {
      setFormData((prev) => ({ ...prev, district: "" }));
    }
  }, [formData.countryCode, formData.stateCode]);

 useEffect(() => {
  if (formData.employee_division && formData.employee_division !== 'Other') {
    // Filter subdivisions that belong to the selected division
    const filtered = dropdownOptions.subdivisions.filter(
      subdiv => subdiv.division.toString() === formData.employee_division
    );
    setFilteredSubdivisions(filtered);
  } else {
    setFilteredSubdivisions([]);
  }
}, [formData.employee_division, dropdownOptions.subdivisions]);

   const fetchDropdownData = useCallback(async () => {
  try {
    const endpoints = [
      { name: 'education', url: 'https://tdtlworld.com/dss-kaas-backend/master/educations/' },
      { name: 'occupation', url: 'https://tdtlworld.com/dss-kaas-backend/master/occupations/' },
      { name: 'designations', url: 'https://tdtlworld.com/dss-kaas-backend/master/designations/' },
      { name: 'divisions', url: 'https://tdtlworld.com/dss-kaas-backend/master/divisions/' },
      { name: 'departments', url: 'https://tdtlworld.com/dss-kaas-backend/master/departments/' },
      { name: 'subdivisions', url: 'https://tdtlworld.com/dss-kaas-backend/master/subdivisions/' },
    ];

    const responses = await Promise.all(
      endpoints.map(async endpoint => {
        try {
          const res = await axios.get(endpoint.url, { 
            headers: { Authorization: `Bearer ${token}` } 
          });
          
          // Transform data for divisions and subdivisions
          if (endpoint.name === 'divisions') {
            return {
              name: endpoint.name,
              data: res.data.map(item => ({
                id: item.id.toString(),
                name: item.name
              }))
            };
          } else if (endpoint.name === 'subdivisions') {
            return {
              name: endpoint.name,
              data: res.data.map(item => ({
                id: item.id.toString(),
                name: item.name,
                division: item.division.toString() // Make sure this matches your API response
              }))
            };
          }
          
          return {
            name: endpoint.name,
            data: Array.isArray(res.data) ? res.data.map(item => item.name || item) : []
          };
        } catch (err) {
          console.error(`Error fetching ${endpoint.name}:`, err);
          // Provide fallback data in case of Network Errors so the page remains functional
          if (endpoint.name === 'occupation') return { name: 'occupation', data: ['Agriculture', 'Student', 'Doctor', 'Consultant'] };
          if (endpoint.name === 'education') return { name: 'education', data: ['High School', 'Bachelor', 'Master', 'PhD'] };
          if (endpoint.name === 'designations') return { name: 'designations', data: ['Manager', 'Developer', 'Analyst'] };
          if (endpoint.name === 'departments') return { name: 'departments', data: ['IT', 'HR', 'Sales'] };
          if (endpoint.name === 'divisions') return { name: 'divisions', data: [{id: '1', name: 'Livestock'}, {id: '2', name: 'Poultry'}] };
          if (endpoint.name === 'subdivisions') return { name: 'subdivisions', data: [{id: '1', name: 'Dairy', division: '1'}, {id: '2', name: 'Broiler', division: '2'}] };
          return { name: endpoint.name, data: [] };
        }
      })
    );

    const dropdownData = {};
    responses.forEach(response => {
      dropdownData[response.name] = response.data;
    });

    setDropdownOptions(dropdownData);
  } catch (error) {
    console.error('Error fetching dropdown data:', error);
    Swal.fire("Error", "Could not load dropdown options", "error");
  }
}, [token]);

   const fetchUsers = useCallback(() => {
    setLoading(true);
    axios
      .get("https://tdtlworld.com/dss-kaas-backend/lms/all-users/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const mappedUsers = res.data.users.map((user) => ({
          id: user.user_id,
          first_name: user.first_name || "",
          middle_name: user.middle_name || "",
          last_name: user.last_name || "",
          name: `${user.first_name || ""} ${user.middle_name || ""} ${
            user.last_name || ""
          }`.replace(/\s+/g, " ").trim(),
          email: user.email || "",
          mobile_number: user.mobile_number || "N/A",
          role_id: user.role_id,
          role: idToRoleMap[user.role_id] || "Unknown Role",
          address_line1: user.address_line1 || "",
          village: user.village || "",
          tehsil: user.tehsil || "",
          district: user.district || "",
          state_address: user.state_address || "",
          country: user.country || "",
          pin_code: user.pin_code || "",
          occupation: user.occupation || "",
          education: user.education || "",
          degree: user.degree || "",
          farm_type: user.farm_type || "",
          farmer_agriculture_type: user.farmer_agriculture_type || "",
          farmer_livestock_type: user.farmer_livestock_type || "",
          farmer_poultry_type: user.farmer_poultry_type || "",
          farmer_aquaculture_type: user.farmer_aquaculture_type || "",
          doctor_specialization: user.doctor_specialization || "",
          business_nature: user.business_nature || "",
          business_company_name: user.business_company_name || "",
          business_company_address: user.business_company_address || "",
          service_company_name: user.service_company_name || "",
          service_designation: user.service_designation || "",
          consultant_area: user.consultant_area || "",
          employee_id: user.employee_id || "",
          employee_department: user.employee_department || "",
          employee_designation: user.employee_designation || "",
          employee_division: user.employee_division || "",
          employee_subdivision: user.employee_subdivision || "",
          employee_headquarter: user.employee_headquarter || "",
        }));
        setUsers(mappedUsers);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        Swal.fire("Error", "Could not fetch users. Check API or network.", "error");
        setLoading(false);
      });
  }, [token]);

  const fetchingRef = React.useRef(false);

  useEffect(() => {
    if (!token || fetchingRef.current) return;
    
    const initData = async () => {
      fetchingRef.current = true;
      try {
        await Promise.all([
          fetchDropdownData(),
          fetchUsers()
        ]);
      } finally {
        fetchingRef.current = false;
      }
    };

    initData();
  }, [token, fetchDropdownData, fetchUsers]);

  useEffect(() => {
    if (!token) return;
    fetchDropdownData();
    fetchUsers();
    setCountries(Country.getAllCountries());
  }, [fetchDropdownData, fetchUsers, token]);
  

   const renderEducationDropdown = () => (
    <select
      name="education"
      value={formData.education}
      onChange={handleInputChange}
      required
      style={inputStyle}
    >
      <option value="">Select Education</option>
      {dropdownOptions.education.map((education, index) => (
        <option key={index} value={education}>
          {education}
        </option>
      ))}
    </select>
  );

  const renderOccupationDropdown = () => (
    <select
      name="occupation"
      value={formData.occupation}
      onChange={handleInputChange}
      required
      style={inputStyle}
    >
      <option value="">Select Occupation</option>
      {dropdownOptions.occupation.map((occupation, index) => (
        <option key={index} value={occupation}>
          {occupation}
        </option>
      ))}
    </select>
  );

  const renderDesignationDropdown = () => (
    <select
      name="employee_designation"
      value={formData.employee_designation}
      onChange={handleInputChange}
      required
      style={inputStyle}
    >
      <option value="">Select Designation</option>
      {dropdownOptions.designations.map((designation, index) => (
        <option key={index} value={designation}>
          {designation}
        </option>
      ))}
      <option value="Other">Other</option>
    </select>
  );

const renderDivisionDropdown = () => (
    <select
      name="employee_division"
      value={formData.employee_division}
      onChange={handleInputChange}
      style={inputStyle}
      required
    >
      <option value="">Select Division</option>
      {dropdownOptions.divisions.map((division) => (
        <option key={division.id} value={division.id}>
          {division.name}
        </option>
      ))}
      <option value="Other">Other</option>
    </select>
  );
 const renderSubDivisionDropdown = () => (
  <select
    name="employee_subdivision"
    value={formData.employee_subdivision}
    onChange={handleInputChange}
    style={inputStyle}
    disabled={!formData.employee_division}
    required
  >
    <option value="">Select SubDivision</option>
    {filteredSubdivisions.map((subdivision) => (
      <option key={subdivision.id} value={subdivision.id}>
        {subdivision.name}
      </option>
    ))}
    <option value="Other">Other</option>
  </select>
);
  const renderDepartmentDropdown = () => (
    <select
      name="employee_department"
      value={formData.employee_department}
      onChange={handleInputChange}
      required
      style={inputStyle}
    >
      <option value="">Select Department</option>
      {dropdownOptions.departments.map((department, index) => (
        <option key={index} value={department}>
          {department}
        </option>
      ))}
      <option value="Other">Other</option>
    </select>
  );

  const filteredUsers = users.filter((user) => {
    const searchTermLower = searchTerm.toLowerCase();
    const matchesSearch =
      (user.name && user.name.toLowerCase().includes(searchTermLower)) ||
      (user.email && user.email.toLowerCase().includes(searchTermLower)) ||
      (user.mobile_number && user.mobile_number.includes(searchTermLower)) ||
      (user.occupation &&
        user.occupation.toLowerCase().includes(searchTermLower));
    const matchesRole = filterRole === "" || user.role === filterRole;
    return matchesSearch && matchesRole;
  });


  const columns = [
    { key: "name", label: "Name", sortable: true },
    { key: "email", label: "Email", sortable: true },
    { key: "mobile_number", label: "Mobile", sortable: true },
    { key: "role", label: "Role", sortable: true },
    { key: "occupation", label: "Occupation", sortable: true },
    { key: "education", label: "Education", sortable: true },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => handleEditClick(row)}
            style={{
              background: "none",
              border: "none",
              color: "#7366ff",
              cursor: "pointer",
              fontSize: "16px",
            }}
            aria-label="Edit user"
          >
            <FaEdit />
          </button>
          <button
            onClick={() => handleDeleteClick(row)}
            style={{
              background: "none",
              border: "none",
              color: "#ff5370",
              cursor: "pointer",
              fontSize: "16px",
            }}
            aria-label="Delete user"
          >
            <FaTrash />
          </button>
        </div>
      ),
    },
  ];

  // CSC-LIB: Updated input handler for location data
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newFormData = { ...formData, [name]: value };

    if (name === "country") {
      const selectedCountry = Country.getCountryByCode(value);
      newFormData = {
        ...newFormData,
        country: selectedCountry?.name || "",
        countryCode: selectedCountry?.isoCode || "",
        // Reset dependent fields
        state_address: "",
        stateCode: "",
        district: "",
      };
    } else if (name === "state_address") {
      const selectedState = State.getStateByCodeAndCountry(
        value,
        formData.countryCode
      );
      newFormData = {
        ...newFormData,
        state_address: selectedState?.name || "",
        stateCode: selectedState?.isoCode || "",
        // Reset dependent field
        district: "",
      };
    } else if (name === "role") {
      newFormData = { ...newFormData, role_id: roleToIdMap[value] || null };
    } else if (name === "occupation") {
      const resetFields = {
        farm_type: "",
        farmer_agriculture_type: "",
        farmer_livestock_type: "",
        farmer_poultry_type: "",
        farmer_aquaculture_type: "",
        doctor_specialization: "",
        business_nature: "",
        business_company_name: "",
        business_company_address: "",
        service_company_name: "",
        service_designation: "",
        consultant_area: "",
        employee_id: "",
        employee_department: "",
        employee_designation: "",
        employee_division: "",
        employee_headquarter: "",
        employee_other_department: "",
        employee_other_designation: "",
        employee_other_division: "",
      };
      newFormData = { ...newFormData, ...resetFields };
    } else if (name === "farm_type") {
      newFormData = {
        ...newFormData,
        farmer_agriculture_type: "",
        farmer_livestock_type: "",
        farmer_poultry_type: "",
        farmer_aquaculture_type: "",
      };
    }else if (name === "employee_division") {
      // When division changes, reset subdivision
      newFormData = {
        ...newFormData,
        employee_subdivision: "",
        employee_other_subdivision: ""
      };
    }

    setFormData(newFormData);
  };

  const preparePayload = (data) => {
    const payload = { ...data };
    payload.role_id = roleToIdMap[data.role] || null;
    delete payload.confirm_email;
    delete payload.confirm_password;
    // CSC-LIB: Remove helper codes not needed by backend
    delete payload.countryCode;
    delete payload.stateCode;

    if (payload.password === "") delete payload.password;
    if (
      payload.employee_department === "Other" &&
      payload.employee_other_department
    )
      payload.employee_department = payload.employee_other_department;
    if (
      payload.employee_designation === "Other" &&
      payload.employee_other_designation
    )
      payload.employee_designation = payload.employee_other_designation;
   if (payload.employee_division && payload.employee_division !== 'Other') {
      const divisionObj = dropdownOptions.divisions.find(d => d.id === payload.employee_division);
      payload.employee_division = divisionObj ? divisionObj.name : '';
    } else if (payload.employee_division === 'Other' && payload.employee_other_division) {
      payload.employee_division = payload.employee_other_division;
    }

    // Handle subdivision
    if (payload.employee_subdivision && payload.employee_subdivision !== 'Other') {
    const subdivisionObj = dropdownOptions.subdivisions.find(
      s => s.id.toString() === payload.employee_subdivision
    );
    payload.employee_subdivision = subdivisionObj ? subdivisionObj.name : '';
  } else if (payload.employee_subdivision === 'Other' && payload.employee_other_subdivision) {
    payload.employee_subdivision = payload.employee_other_subdivision;
  }
    delete payload.employee_other_department;
    delete payload.employee_other_designation;
    delete payload.employee_other_division;
    return payload;
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirm_password) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }
    if (formData.email !== formData.confirm_email) {
      Swal.fire("Error", "Emails do not match!", "error");
      return;
    }
    setFormLoading(true);
    const payload = preparePayload(formData);

    try {
      await axios.post(
        "https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setFormLoading(false);
      setShowAddModal(false);
      setFormData(initialFormData);
      fetchUsers();

      Swal.fire("Success", "User added successfully!", "success");
    } catch (error) {
      setFormLoading(false);

      console.error(
        "Failed to add user:",
        error.response ? error.response : error
      );

      let errorMessage = "Server error";

     if (error.response) {
  const contentType = error.response.headers["content-type"] || "";

  if (contentType.includes("application/json")) {
    const data = error.response.data;
    
    // Handle string errors
    if (typeof data === "string") {
      errorMessage = data;
    } 
    // Handle detail/message errors
    else if (data.detail) {
      errorMessage = data.detail;
    } 
    else if (data.message) {
      errorMessage = data.message;
    } 
    // Handle validation errors
    else if (typeof data === "object") {
      const messages = [];
      for (const key in data) {
        // Format field name (convert snake_case to Title Case)
        const fieldName = key.replace(/_/g, ' ')
                           .replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        
        // Get the error message(s)
        const errorText = Array.isArray(data[key]) 
          ? data[key].join(", ")
          : data[key];
        
        // Standardize error messages
        const displayText = errorText
          .replace("This field may not be blank.", `${fieldName} is required.`)
          .replace("This field is required.", `${fieldName} is required.`);
        
        messages.push(displayText);
      }
      errorMessage = messages.join("<br>");
    }
  } else {
    errorMessage = "Unexpected server response. Please try again.";
  }
}

Swal.fire({
  title: "Error",
  html: `Failed to add user:<br>${errorMessage}`,
  icon: "error"
});
    }
  };

  // CSC-LIB: handleEditClick is now async to handle data lookups
  const handleEditClick = async (user) => {
    setCurrentUser(user);

    // CSC-LIB: Find country and state codes from names saved in the DB
    const countryData = Country.getAllCountries().find(
      (c) => c.name === user.country
    );
    const stateData = countryData
      ? State.getStatesOfCountry(countryData.isoCode).find(
          (s) => s.name === user.state_address
        )
      : null;

      let subdivisionId = '';
  if (user.employee_subdivision) {
    const subdivision = dropdownOptions.subdivisions.find(
      s => s.name === user.employee_subdivision
    );
    subdivisionId = subdivision ? subdivision.id.toString() : 'Other';
  }

    const userFormData = {
      ...initialFormData,
      id: user.id,
      first_name: user.first_name || "",
      middle_name: user.middle_name || "",
      last_name: user.last_name || "",
      email: user.email || "",
      confirm_email: user.email || "",
      mobile_number: user.mobile_number || "",
      role: user.role || "Student",
      role_id: user.role_id || 2,
      address_line1: user.address_line1 || "",
      village: user.village || "",
      tehsil: user.tehsil || "",
      district: user.district || "",
      state_address: user.state_address || "",
      country: user.country || "",
      pin_code: user.pin_code || "",
      // CSC-LIB: Set the codes for the dropdowns to work
      countryCode: countryData?.isoCode || "",
      stateCode: stateData?.isoCode || "",
      occupation: user.occupation || "",
      education: user.education || "",
      degree: user.degree || "",
      farm_type: user.farm_type || "",
      farmer_agriculture_type: user.farmer_agriculture_type || "",
      farmer_livestock_type: user.farmer_livestock_type || "",
      farmer_poultry_type: user.farmer_poultry_type || "",
      farmer_aquaculture_type: user.farmer_aquaculture_type || "",
      doctor_specialization: user.doctor_specialization || "",
      business_nature: user.business_nature || "",
      business_company_name: user.business_company_name || "",
      business_company_address: user.business_company_address || "",
      service_company_name: user.service_company_name || "",
      service_designation: user.service_designation || "",
      consultant_area: user.consultant_area || "",
      employee_id: user.employee_id || "",
      employee_department: user.employee_department || "",
      employee_designation: user.employee_designation || "",
      employee_division: user.employee_division || "",
 employee_subdivision: subdivisionId,
    employee_other_subdivision: subdivisionId === 'Other' ? user.employee_subdivision : '',
          employee_headquarter: user.employee_headquarter || "",
      password: "",
      confirm_password: "",
    };

   if (
  userFormData.employee_department &&
  !dropdownOptions.departments.includes(userFormData.employee_department)
) {
  userFormData.employee_other_department = userFormData.employee_department;
  userFormData.employee_department = "Other";
}
if (
  userFormData.employee_designation &&
  !dropdownOptions.designations.includes(userFormData.employee_designation)
) {
  userFormData.employee_other_designation = userFormData.employee_designation;
  userFormData.employee_designation = "Other";
}
if (
  userFormData.employee_division &&
  !dropdownOptions.divisions.includes(userFormData.employee_division)
) {
  userFormData.employee_other_division = userFormData.employee_division;
  userFormData.employee_division = "Other";
}
if (
  userFormData.employee_subdivision &&
  !dropdownOptions.subdivisions.includes(userFormData.employee_subdivision)
) {
  userFormData.employee_other_subdivision = userFormData.employee_subdivision;
  userFormData.employee_subdivision = "Other";
}


setFormData(userFormData);
setShowEditModal(true);
  }
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (formData.password && formData.password !== formData.confirm_password) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }
    if (
      formData.email !== formData.confirm_email &&
      currentUser?.email !== formData.email
    ) {
      Swal.fire("Error", "Emails do not match for confirmation!", "error");
      return;
    }
    setFormLoading(true);
    const payload = preparePayload(formData);
    delete payload.id;

    try {
      await axios.patch(
        `https://tdtlworld.com/dss-kaas-backend/lms/users-update/${currentUser.id}/`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFormLoading(false);
      setShowEditModal(false);
      setFormData(initialFormData);
      fetchUsers();
      Swal.fire("Success", "User updated successfully!", "success");
    } catch (error) {
      setFormLoading(false);
      console.error(
        "Failed to update user:",
        error.response ? error.response.data : error
      );
      Swal.fire(
        "Error",
        `Failed to update user: ${
          error.response?.data?.detail ||
          error.response?.data?.message ||
          Object.values(error.response?.data || {}).join(", ") ||
          "Server error"
        }`,
        "error"
      );
    }
  };

  const handleDeleteClick = (user) => {
    setCurrentUser(user);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setFormLoading(true);
    try {
      await axios.delete(
        `https://tdtlworld.com/dss-kaas-backend/lms/users-delete/${currentUser.id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFormLoading(false);
      setShowDeleteModal(false);
      fetchUsers();
      Swal.fire("Deleted!", "User has been deleted.", "success");
    } catch (error) {
      setFormLoading(false);
      console.error("Failed to delete user:", error);
      Swal.fire("Error", "Failed to delete user.", "error");
    }
  };

  // Styles (theme-aware)
  const modalBackdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    backdropFilter: "blur(4px)",
  };
  const modalContentStyle = {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: "24px",
    padding: "0px",
    width: "clamp(500px, 80vw, 900px)",
    maxWidth: "95%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: isDark 
      ? "0 20px 50px rgba(0,0,0,0.5)" 
      : "0 20px 50px rgba(0,0,0,0.15)",
    border: isDark ? `1px solid ${theme.palette.divider}` : "none",
  };
  const modalHeaderStyle = {
    padding: "20px 24px",
    borderBottom: `1px solid ${alpha(GOLD, 0.1)}`,
    background: isDark
      ? `linear-gradient(135deg, ${GOLD} 0%, #8B6B00 100%)`
      : `linear-gradient(135deg, ${GOLD} 0%, #B8860B 100%)`,
    position: "sticky",
    textAlign: "left",
    top: 0,
    zIndex: 10,
    color: isDark ? "#000" : "#0D0D0D",
    fontWeight: 800,
  };
  const modalBodyStyle = { 
    padding: "20px", 
    overflowY: "auto", 
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper, 
  };
  const modalFooterStyle = {
    padding: "15px 20px",
    borderTop: `1px solid ${theme.palette.divider}`,
    textAlign: "right",
    backgroundColor: theme.palette.background.paper,
    position: "sticky",
    bottom: 0,
    zIndex: 1,
  };
  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    border: `1px solid ${isDark ? alpha(theme.palette.divider, 0.3) : alpha(GOLD, 0.3)}`,
    borderRadius: "12px",
    boxSizing: "border-box",
    fontSize: "0.95rem",
    fontFamily: "'Outfit', sans-serif",
    backgroundColor: isDark ? alpha(theme.palette.common.white, 0.05) : "white",
    color: theme.palette.text.primary,
    outline: "none",
  };
  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };
  const sectionStyle = {
    borderBottom: `2px solid ${alpha(GOLD, 0.1)}`,
    paddingBottom: "12px",
    marginBottom: "20px",
    marginTop: "30px",
    fontSize: "1.2rem",
    fontWeight: "700",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: GOLD,
  };
  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    marginBottom: "25px",
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setShowExcelData(false); 

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(firstSheet);

      const requiredFields = [
        "first_name",
        "last_name",
        "email",
        "mobile_number",
        "address_line1",
        "country",
        "state_address",
        "district",
        "pin_code",
        "occupation",
        "education",
      ];

      const validatedData = jsonData.map((row, index) => {
        const errors = [];

        requiredFields.forEach((field) => {
          if (!row[field]) {
            errors.push(`Missing ${field} in row ${index + 2}`);
          }
        });

        if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
          errors.push(`Invalid email format in row ${index + 2}`);
        }

        return {
          first_name: row.first_name || "",
          middle_name: row.middle_name || "",
          last_name: row.last_name || "",
          email: row.email || "",
          mobile_number: row.mobile_number || "",
          role: "Student",
          role_id: 2,
          address_line1: row.address_line1 || "",
          village: row.village || "",
          tehsil: row.tehsil || "",
          district: row.district || "",
          state_address: row.state_address || "",
          country: row.country || "",
          pin_code: row.pin_code || "",
          occupation: row.occupation || "",
          education: row.education || "",
          degree: row.degree || "",
          farm_type: row.farm_type || "",
          farmer_agriculture_type: row.farmer_agriculture_type || "",
          farmer_livestock_type: row.farmer_livestock_type || "",
          farmer_poultry_type: row.farmer_poultry_type || "",
          farmer_aquaculture_type: row.farmer_aquaculture_type || "",
          doctor_specialization: row.doctor_specialization || "",
          business_nature: row.business_nature || "",
          business_company_name: row.business_company_name || "",
          business_company_address: row.business_company_address || "",
          service_company_name: row.service_company_name || "",
          service_designation: row.service_designation || "",
          consultant_area: row.consultant_area || "",
          employee_id: row.employee_id || "",
          employee_department: row.employee_department || "",
          employee_designation: row.employee_designation || "",
          employee_division: row.employee_division || "",
          employee_subdivision: row.employee_subdivision || "",
          employee_headquarter: row.employee_headquarter || "",
          password: row.employee_password || "",
          confirm_password: row.employee_c_password ||"",
          _errors: errors.length > 0 ? errors : null,
          _isValid: errors.length === 0,
        };
      });

      setExcelData(validatedData);
      setShowPreview(true);
    };
    reader.readAsArrayBuffer(file);
  };

  const importUsersFromExcel = async () => {
    setFormLoading(true);
    setUploadProgress(0);

    const validUsers = excelData.filter((user) => user._isValid);
    const totalUsers = validUsers.length;
    let successCount = 0;
    const importedUsers = [];
    const errorMessages = [];

    for (let i = 0; i < validUsers.length; i++) {
      const user = validUsers[i];
      try {
        const payload = { ...user };
        delete payload._errors;
        delete payload._isValid;
        delete payload.confirm_password;

        payload.role_id = 2;

        await axios.post(
          "https://tdtlworld.com/dss-kaas-backend/auth/admin/create-user/",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        successCount++;
        importedUsers.push(
          `${user.first_name} ${user.last_name} (${user.email})`
        );
      }
      catch (error) {
  const data = error.response?.data;
  let errorText = "Server error";

  if (typeof data === "string") {
    errorText = data;
  } else if (data?.message) {
    errorText = data.message;
  } else if (data?.error) {
    errorText = data.error;
  } else if (typeof data === "object") {
    // Handle field-specific errors (e.g., {"password": ["This field is required."]})
    const fieldErrors = Object.entries(data).flatMap(([field, errors]) => {
      return errors.map((err) => `${field}:${err.toLowerCase()}`);
    });
    errorText = fieldErrors.join(", ");
  } else if (error.message) {
    errorText = error.message;
  }

  errorMessages.push({
    user: `${user.first_name} ${user.last_name}`,
    error: errorText,
  });
}


      setUploadProgress(Math.floor(((i + 1) / totalUsers) * 100));
    }

    setFormLoading(false);
    setImportResults({
      total: validUsers.length,
      success: successCount,
      failed: validUsers.length - successCount,
      importedUsers,
      errorMessages,
    });

    // Refresh user list
    fetchUsers();
  };

  const downloadTemplate = () => {
    // Create template with all required fields
    const templateData = [
      {
        first_name: "John",
        middle_name: "",
        last_name: "Doe",
        email: "john.doe@example.com",
        mobile_number: "9876543210",
        role: "Student",
        address_line1: "123 Main St",
        village: "",
        tehsil: "",
        district: "Mumbai",
        state_address: "Maharashtra",
        country: "India",
        pin_code: "400001",
        occupation: "Farmer",
        education: "Graduate",
        degree: "B.Sc Agriculture",
        farm_type: "Agriculture",
    farmer_agriculture_type: "Crop farming",
    farmer_livestock_type: "",
    farmer_poultry_type: "",
    farmer_aquaculture_type: "",
    
    // Professional Fields
    doctor_specialization: "",
    business_nature: "",
    business_company_name: "",
    business_company_address: "",
    service_company_name: "",
    service_designation: "",
    consultant_area: "",
    
    // Employee Fields
    employee_id: "",
    employee_department: "",
    employee_designation: "",
    employee_division: "",
    employee_subdivision:"",
    employee_headquarter: "",
    
    // Password Fields
    password: "sample@123",
    confirm_password: "sample@123",
            
      },
    ];

    // Add all other possible fields as empty to show structure
    const allFields = Object.keys(initialFormData).filter(
      (f) => !["confirm_email", "confirm_password", "password"].includes(f)
    );
    allFields.forEach((field) => {
      if (!templateData[0][field]) {
        templateData[0][field] = "";
      }
    });

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "UsersTemplate");
    XLSX.writeFile(wb, "User_Import_Example.xlsx");
  };

  const closeImportResults = () => {
    setImportResults(null);
    setShowUploadModal(false);
    setExcelData([]);
    setShowPreview(false);
    setUploadProgress(0);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 3, color: 'text.primary', fontFamily: "'Outfit', sans-serif" }}>
        User <Box component="span" sx={{ color: GOLD }}>Management</Box>
      </Typography>

      <Card>
        {/* Search and Filter UI (unchanged) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              minWidth: "250px",
              flexGrow: 1,
            }}
          >
            <FaSearch
              style={{ position: "absolute", left: "12px", color: isDark ? alpha(theme.palette.text.primary, 0.5) : "#888" }}
            />
            <input
              type="text"
              placeholder="Search by name, email, mobile, occupation..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={inputStyle}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaFilter style={{ color: GOLD }} />
              <select
                value={filterRole}
                onChange={(e) => setFilterRole(e.target.value)}
                style={{ ...inputStyle, width: 'auto', minWidth: '150px' }}
              >
                <option value="">All Roles</option>
                {Object.keys(roleToIdMap).map((roleName) => (
                  <option key={roleName} value={roleName}>
                    {roleName}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={() => setShowUploadModal(true)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 25px",
                background: `linear-gradient(45deg, ${GOLD} 30%, #F5D76E 90%)`,
                color: "#0D0D0D",
                border: "none",
                borderRadius: "50px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "700",
                boxShadow: "0 4px 15px rgba(212, 175, 55, 0.4)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(212, 175, 55, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(212, 175, 55, 0.4)";
              }}
            >
              <FaFileExcel size={18} />
              Import Users
            </button>
            <button
              onClick={() => {
                setFormData(initialFormData);
                setShowAddModal(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 25px",
                background: `linear-gradient(45deg, ${GOLD} 30%, #F5D76E 90%)`,
                color: "#0D0D0D",
                border: "none",
                borderRadius: "50px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "700",
                boxShadow: "0 4px 15px rgba(212, 175, 55, 0.4)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(212, 175, 55, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(212, 175, 55, 0.4)";
              }}
            >
              <FaUserPlus size={18} />
              Add User
            </button>
          </div>
        </div>
        {loading ? (
          <p>Loading users...</p>
        ) : (
          <Table
            columns={columns}
            data={filteredUsers}
            pagination={true}
            itemsPerPage={10}
          />
        )}
      </Card>
      {importResults && (
        <div style={modalBackdropStyle}>
          <div style={{ ...modalContentStyle, width: "500px" }}>
            <div style={modalHeaderStyle}>
              <h2 style={{ margin: 0 }}>Import Results</h2>
            </div>
            <div style={modalBodyStyle}>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                  Import completed: {importResults.success} of{" "}
                  {importResults.total} users imported successfully
                </p>

                {importResults.success > 0 && (
                  <div style={{ marginTop: "15px" }}>
                    <h4 style={{ marginBottom: "10px" }}>Imported Users:</h4>
                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "12px",
                        padding: "10px",
                        backgroundColor: isDark ? alpha(theme.palette.common.white, 0.02) : "#fafafa",
                      }}
                    >
                      {importResults.importedUsers.map((user, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "8px 0",
                            borderBottom:
                              index < importResults.importedUsers.length - 1
                                ? "1px solid #f0f0f0"
                                : "none",
                          }}
                        >
                          {user}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {importResults.failed > 0 && (
                  <div style={{ marginTop: "15px" }}>
                    <h4 style={{ marginBottom: "10px", color: "#ff5370" }}>
                      Failed to import {importResults.failed} users
                    </h4>
                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "12px",
                        padding: "10px",
                        backgroundColor: isDark ? alpha(theme.palette.common.white, 0.02) : "#fafafa",
                      }}
                    >
                      {importResults.errorMessages.map((error, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "8px 0",
                            borderBottom:
                              index < importResults.errorMessages.length - 1
                                ? "1px solid #f0f0f0"
                                : "none",
                          }}
                        >
                          <strong>{error.user}:</strong> {error.error}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div style={modalFooterStyle}>
              <button
                onClick={closeImportResults}
                style={{
                  padding: "8px 15px",
                  background: `linear-gradient(45deg, #FF6600,#B8529E)`,
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Upload Modal */}
      {showUploadModal && !importResults && (
        <div style={modalBackdropStyle}>
          <div style={{ ...modalContentStyle, width: "500px" }}>
            <div style={modalHeaderStyle}>
              <h2 style={{ margin: 0 }}>Import Users from Excel</h2>
            </div>
            <div style={modalBodyStyle}>
              {!showPreview ? (
                <>
                  <p>
                    Upload an Excel file with user data.{" "}
                    <button
                      onClick={downloadTemplate}
                      style={{
                        color: GOLD,
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      Download Template
                    </button>
                  </p>

                  <div
                    style={{
                      border: `2px dashed ${isDark ? theme.palette.divider : "#ddd"}`,
                      padding: "40px 20px",
                      textAlign: "center",
                      margin: "20px 0",
                      borderRadius: "16px",
                      backgroundColor: isDark ? alpha(theme.palette.common.white, 0.02) : "#f9f9f9",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="file"
                      id="excelUpload"
                      accept=".xlsx, .xls"
                      onChange={handleFileUpload}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="excelUpload" style={{ cursor: "pointer" }}>
                      <FaFileExcel
                        style={{
                          fontSize: "48px",
                          color: "#2E7D32",
                          marginBottom: "10px",
                        }}
                      />
                      <p>Click to upload Excel file</p>
                      <p style={{ fontSize: "0.8rem", color: "#666" }}>
                        .xlsx or .xls files only
                      </p>
                    </label>
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h3 style={{ margin: 0 }}>
                      Preview Data ({excelData.length} users)
                    </h3>
                    <div>
                      <span
                        style={{
                          color: excelData.some((u) => !u._isValid)
                            ? "#ff5370"
                            : "#2E7D32",
                          fontWeight: "bold",
                        }}
                      >
                        {excelData.filter((u) => u._isValid).length} valid,{" "}
                        {excelData.filter((u) => !u._isValid).length} with
                        errors
                      </span>
                    </div>
                  </div>
                   <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
              <button
                onClick={() => setShowExcelData(!showExcelData)}
                style={{
                  padding: '8px 15px',
                  background: isDark ? alpha(GOLD, 0.2) : GOLD,
                  color: isDark ? GOLD : 'white',
                  border: isDark ? `1px solid ${GOLD}` : 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontWeight: 'bold',
                }}
              >
                <FaEye />
                {showExcelData ? 'Hide Excel' : 'View Excel'}
              </button>
            </div>

                  <div
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      marginBottom: "20px",
                      border: "1px solid #eee",
                      borderRadius: "5px",
                    }}
                  >
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          background: isDark ? theme.palette.background.paper : "#f8f9fa",
                          zIndex: 1,
                        }}
                      >
                        <tr>
                          <th
                            style={{
                              padding: "12px 15px",
                              borderBottom: `2px solid ${GOLD}`,
                              textAlign: "left",
                              color: GOLD,
                              textTransform: "uppercase",
                              fontSize: "0.75rem",
                              letterSpacing: "1px",
                            }}
                          >
                            Name
                          </th>
                          <th
                            style={{
                              padding: "12px 15px",
                              borderBottom: `2px solid ${GOLD}`,
                              textAlign: "left",
                              color: GOLD,
                              textTransform: "uppercase",
                              fontSize: "0.75rem",
                              letterSpacing: "1px",
                            }}
                          >
                            Email
                          </th>
                          <th
                            style={{
                              padding: "12px 15px",
                              borderBottom: `2px solid ${GOLD}`,
                              textAlign: "left",
                              color: GOLD,
                              textTransform: "uppercase",
                              fontSize: "0.75rem",
                              letterSpacing: "1px",
                            }}
                          >
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {excelData.map((user, index) => (
                          <tr
                            key={index}
                            style={{
                              background: user._isValid
                                ? "transparent"
                                : "rgba(255, 83, 112, 0.1)",
                            }}
                          >
                            <td
                              style={{
                                padding: "12px 15px",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                              }}
                            >
                              {user.first_name} {user.last_name}
                            </td>
                            <td
                              style={{
                                padding: "12px 15px",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                              }}
                            >
                              {user.email}
                            </td>
                            <td
                              style={{
                                padding: "12px 15px",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                              }}
                            >
                              {user._isValid ? (
                                <span style={{ color: "#2E7D32" }}>
                                  ✓ Valid
                                </span>
                              ) : (
                                <div>
                                  <span style={{ color: "#ff5370" }}>
                                    ✗ Errors:
                                  </span>
                                  <ul
                                    style={{
                                      margin: "5px 0 0 0",
                                      paddingLeft: "20px",
                                    }}
                                  >
                                    {user._errors.map((err, i) => (
                                      <li
                                        key={i}
                                        style={{ fontSize: "0.8rem" }}
                                      >
                                        {err}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {uploadProgress > 0 && (
                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "5px",
                        }}
                      >
                        <span>Upload Progress:</span>
                        <span>{uploadProgress}%</span>
                      </div>
                      <div
                        style={{
                          height: "10px",
                          background: isDark ? alpha(theme.palette.common.white, 0.1) : "#eee",
                          borderRadius: "5px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${uploadProgress}%`,
                            background: "#4CAF50",
                            borderRadius: "5px",
                          }}
                        ></div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div style={modalFooterStyle}>
              <button
                onClick={() => {
                  setShowUploadModal(false);
                  setExcelData([]);
                  setShowPreview(false);
                  setUploadProgress(0);
                }}
                style={{
                  padding: "8px 15px",
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Cancel
              </button>
              {showPreview && (
                
                <button
                  onClick={importUsersFromExcel}
                  disabled={
                    formLoading ||
                    excelData.filter((u) => u._isValid).length === 0
                  }
                  style={{
                    padding: "8px 15px",
                    background: `linear-gradient(45deg, #4CAF50, #2E7D32)`,
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    opacity:
                      excelData.filter((u) => u._isValid).length === 0
                        ? 0.5
                        : 1,
                  }}
                >
                  {formLoading ? "Importing..." : "Import Valid Users"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}


{showExcelData && (
  <div style={modalBackdropStyle}>
    <div style={{ ...modalContentStyle, width: '80vw', maxWidth: '1200px', height: '80vh' }}>
      <div style={modalHeaderStyle}>
        <h2 style={{ margin: 0 }}>Excel Data Preview</h2>
      </div>
      <div style={{ ...modalBodyStyle, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ position: 'sticky', top: 0, background: isDark ? theme.palette.background.paper : '#f8f9fa' }}>
            <tr>
              {excelData.length > 0 && Object.keys(excelData[0]).map((key) => (
                !key.startsWith('_') && (
                  <th 
                    key={key}
                    style={{
                      padding: '12px 15px',
                      borderBottom: `2px solid ${GOLD}`,
                      textAlign: 'left',
                      position: 'sticky',
                      top: 0,
                      background: isDark ? theme.palette.background.paper : '#f8f9fa',
                      color: GOLD,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '1px'
                    }}
                  >
                    {key}
                  </th>
                )
              ))}
            </tr>
          </thead>
          <tbody>
            {excelData.map((row, rowIndex) => (
              <tr 
                key={rowIndex}
                style={{
                  background: row._isValid ? 'transparent' : 'rgba(255, 83, 112, 0.1)'
                }}
              >
                {Object.entries(row).map(([key, value]) => (
                  !key.startsWith('_') && (
                    <td
                      key={key}
                      style={{
                        padding: '8px',
                        borderBottom: '1px solid #eee',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '200px'
                      }}
                    >
                      {typeof value === 'object' ? JSON.stringify(value) : value}
                    </td>
                  )
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={modalFooterStyle}>
        <button
          onClick={() => setShowExcelData(false)}
          style={{
            padding: '8px 20px',
            background: GOLD,
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
      {(showAddModal || showEditModal) && (
        <div style={modalBackdropStyle}>
          <div style={modalContentStyle}>
            <div style={modalHeaderStyle}>
              <h2
                style={{ margin: 0, fontSize: "1.5rem", alignItems: "center" }}
              >
                {showAddModal ? "Add New User" : "Edit User"}
              </h2>
            </div>

            <form
              onSubmit={showAddModal ? handleAddSubmit : handleEditSubmit}
              style={modalBodyStyle}
            >
              {/* Personal Info, Credentials sections are unchanged */}
              <h3 style={sectionStyle}>Personal Information</h3>
              <div style={gridContainerStyle}>
                <div>
                  <label style={labelStyle}>First Name*</label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Middle Name</label>
                  <input
                    type="text"
                    name="middle_name"
                    value={formData.middle_name}
                    onChange={handleInputChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Last Name*</label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Mobile Number *</label>
                  <input
                    type="text"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Role*</label>
                  <select
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    style={inputStyle}
                    required
                  >
                    {Object.keys(roleToIdMap).map((roleName) => (
                      <option key={roleName} value={roleName}>
                        {roleName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <h3 style={sectionStyle}>Login Credentials</h3>
              <div style={gridContainerStyle}>
                <div>
                  <label style={labelStyle}>Email*</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Confirm Email*</label>
                  <input
                    type="email"
                    name="confirm_email"
                    value={formData.confirm_email}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>
                    Password
                    {showAddModal ? "*" : " (Leave blank to keep unchanged)"}
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required={showAddModal}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>
                    Confirm Password{showAddModal ? "*" : ""}
                  </label>
                  <input
                    type="password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleInputChange}
                    required={showAddModal}
                    style={inputStyle}
                  />
                </div>
              </div>

              <h3 style={sectionStyle}>Address Information</h3>
              <div style={gridContainerStyle}>
                <div>
                  <label style={labelStyle}>Address Line 1*</label>
                  <input
                    type="text"
                    name="address_line1"
                    value={formData.address_line1}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>

                {/* CSC-LIB: Updated JSX for dynamic dropdowns */}
                <div>
                  <label style={labelStyle}>Country*</label>
                  <select
                    name="country"
                    value={formData.countryCode}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.isoCode} value={country.isoCode}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>State*</label>
                  <select
                    name="state_address"
                    value={formData.stateCode}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                    disabled={!formData.countryCode}
                  >
                    <option value="">Select State</option>
                    {availableStates.map((state) => (
                      <option key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>District / City*</label>
                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                    disabled={!formData.stateCode}
                  >
                    <option value="">Select District / City</option>
                    {availableDistricts.map((district) => (
                      <option key={district.name} value={district.name}>
                        {district.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* CSC-LIB: Tehsil and Village are now text inputs */}
                <div>
                  <label style={labelStyle}>Tehsil / Taluka</label>
                  <input
                    type="text"
                    name="tehsil"
                    value={formData.tehsil}
                    onChange={handleInputChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Village</label>
                  <input
                    type="text"
                    name="village"
                    value={formData.village}
                    onChange={handleInputChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Pin Code*</label>
                  <input
                    type="text"
                    name="pin_code"
                    value={formData.pin_code}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* All other occupation-specific sections are unchanged */}
              <h3 style={sectionStyle}>Occupation and Education</h3>
              <div style={gridContainerStyle}>
                <div>
              <label style={labelStyle}>Occupation*</label>
              {renderOccupationDropdown()}
            </div>
               <div>
              <label style={labelStyle}>Education*</label>
              {renderEducationDropdown()}
            </div>
                <div>
                  <label style={labelStyle}>Degree</label>
                  <input
                    type="text"
                    name="degree"
                    value={formData.degree}
                    onChange={handleInputChange}
                    style={inputStyle}
                  />
                </div>
              </div>
              {formData.occupation === "Farmer" && (
                <>
                  <h3 style={sectionStyle}>Farmer Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Farm Type*</label>
                      <select
                        name="farm_type"
                        value={formData.farm_type}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select Farm Type</option>
                        {farmTypeOptions.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formData.farm_type === "Agriculture" && (
                      <div>
                        <label style={labelStyle}>Agriculture Type*</label>
                        <select
                          name="farmer_agriculture_type"
                          value={formData.farmer_agriculture_type}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select Agriculture Type</option>
                          {agricultureTypeOptions.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {formData.farm_type === "Livestock" && (
                      <div>
                        <label style={labelStyle}>Livestock Type*</label>
                        <select
                          name="farmer_livestock_type"
                          value={formData.farmer_livestock_type}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select Livestock Type</option>
                          {livestockTypeOptions.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {formData.farm_type === "Poultry" && (
                      <div>
                        <label style={labelStyle}>Poultry Type*</label>
                        <select
                          name="farmer_poultry_type"
                          value={formData.farmer_poultry_type}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select Poultry Type</option>
                          {poultryTypeOptions.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {formData.farm_type === "Aquaculture" && (
                      <div>
                        <label style={labelStyle}>Aquaculture Type*</label>
                        <select
                          name="farmer_aquaculture_type"
                          value={formData.farmer_aquaculture_type}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select Aquaculture Type</option>
                          {aquacultureTypeOptions.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                </>
              )}
              {formData.occupation === "Doctor" && (
                <>
                  <h3 style={sectionStyle}>Doctor Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Specialization*</label>
                      <select
                        name="doctor_specialization"
                        value={formData.doctor_specialization}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select Specialization</option>
                        {doctorSpecializationOptions.map((spec) => (
                          <option key={spec} value={spec}>
                            {spec}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
              {formData.occupation === "Business" && (
                <>
                  <h3 style={sectionStyle}>Business Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Nature of Business*</label>
                      <select
                        name="business_nature"
                        value={formData.business_nature}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select Nature</option>
                        {businessNatureOptions.map((nature) => (
                          <option key={nature} value={nature}>
                            {nature}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Company Name*</label>
                      <input
                        type="text"
                        name="business_company_name"
                        value={formData.business_company_name}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>Company Address*</label>
                      <input
                        type="text"
                        name="business_company_address"
                        value={formData.business_company_address}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>
                  </div>
                </>
              )}
              {formData.occupation === "Service" && (
                <>
                  <h3 style={sectionStyle}>Service Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Company Name*</label>
                      <input
                        type="text"
                        name="service_company_name"
                        value={formData.service_company_name}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>
                      <div>
                <label style={labelStyle}>Designation*</label>
                {renderDesignationDropdown()}
                {formData.service_designation === "Other" && (
                  <input
                    type="text"
                    name="service_designation"
                    value={formData.service_designation}
                    onChange={handleInputChange}
                    placeholder="Enter Designation"
                    required
                    style={{ ...inputStyle, marginTop: "5px" }}
                  />
                )}
              </div>
                  </div>
                </>
              )}
              {formData.occupation === "Consultant" && (
                <>
                  <h3 style={sectionStyle}>Consultant Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Consultant Area*</label>
                      <select
                        name="consultant_area"
                        value={formData.consultant_area}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select Area</option>
                        {consultantAreaOptions.map((area) => (
                          <option key={area} value={area}>
                            {area}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
              {formData.occupation === "Company employee" && (
                <>
                  <h3 style={sectionStyle}>Employee Details</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Employee ID</label>
                      <input
                        type="text"
                        name="employee_id"
                        value={formData.employee_id}
                        onChange={handleInputChange}
                        style={inputStyle}
                        required
                      />
                    </div>
                     <div>
                <label style={labelStyle}>Department*</label>
                {renderDepartmentDropdown()}
                {formData.employee_department === "Other" && (
                  <input
                    type="text"
                    name="employee_other_department"
                    value={formData.employee_other_department}
                    onChange={handleInputChange}
                    placeholder="Enter Department"
                    required
                    style={{ ...inputStyle, marginTop: "5px" }}
                  />
                )}
              </div>
                    <div>
                <label style={labelStyle}>Designation*</label>
                {renderDesignationDropdown()}
                {formData.employee_designation === "Other" && (
                  <input
                    type="text"
                    name="employee_other_designation"
                    value={formData.employee_other_designation}
                    onChange={handleInputChange}
                    placeholder="Enter Designation"
                    required
                    style={{ ...inputStyle, marginTop: "5px" }}
                  />
                )}
              </div>
                     <div>
                <label style={labelStyle}>Division*</label>
                {renderDivisionDropdown()}
                {formData.employee_division === "Other" && (
                  <input
                    type="text"
                    name="employee_other_division"
                    value={formData.employee_other_division}
                    onChange={handleInputChange}
                    placeholder="Enter Division"
                  
                    style={{ ...inputStyle, marginTop: "5px" }}
                  />
                )}
              </div>
              <div>
                <label style={labelStyle}>SubDivision*</label>
                {renderSubDivisionDropdown()}
                {formData.employee_subdivision === "Other" && (
                  <input
                    type="text"
                    name="employee_other_subdivision"
                    value={formData.employee_other_subdivision}
                    onChange={handleInputChange}
                    placeholder="Enter SubDivision"
                    
                    style={{ ...inputStyle, marginTop: "5px" }}
                  />
                )}
              </div>
                    <div>
                      <label style={labelStyle}>Headquarter</label>
                      <input
                        type="text"
                        name="employee_headquarter"
                        value={formData.employee_headquarter}
                        onChange={handleInputChange}
                        style={inputStyle}
                      />
                    </div>
                  </div>
                </>
              )}
            </form>
            <div style={modalFooterStyle}>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  setShowEditModal(false);
                  setFormData(initialFormData);
                }}
                style={{
                  padding: "8px 15px",
                  background: `linear-gradient(45deg, #FF6600,#B8529E)`,
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={showAddModal ? handleAddSubmit : handleEditSubmit}
                disabled={formLoading}
                style={{
                  padding: "8px 15px",
                  background: `linear-gradient(45deg, #FF6600,#B8529E)`,
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {formLoading
                  ? "Processing..."
                  : showAddModal
                  ? "Add User"
                  : "Update User"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div style={modalBackdropStyle}>
          <div style={{ ...modalContentStyle, width: "400px" }}>
            <div style={modalHeaderStyle}>
              <h2 style={{ margin: 0 }}>Confirm Delete</h2>
            </div>
            <div style={{ ...modalBodyStyle, textAlign: "center" }}>
              <p>
                Are you sure you want to delete user:{" "}
                <strong>{currentUser?.name}</strong>?
              </p>
              <p>This action cannot be undone.</p>
            </div>
            <div style={modalFooterStyle}>
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  padding: "8px 15px",
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                disabled={formLoading}
                style={{
                  padding: "8px 15px",
                  background: `linear-gradient(45deg, #FF6600,#B8529E)`,
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {formLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
